export default  {
  "100": "Targ Rybny 01",
  "101": "Port Lotniczy 01",
  "102": "Port Lotniczy 02",
  "103": "Port Lotniczy 03",
  "110": "Muzeum II Wojny Światowej 02",
  "114": "Wrzeszcz PKP 03",
  "115": "Wrzeszcz PKP 04",
  "116": "Wrzeszcz PKP 05",
  "117": "Oliwa PKP 04",
  "118": "Oliwa PKP 02",
  "119": "Oliwa PKP 03",
  "120": "Oliwa 07",
  "121": "Żabianka SKM 02",
  "122": "Jelitkowo Kapliczna 03",
  "123": "Przymorze SKM 03",
  "124": "Zaspa SKM 02",
  "125": "Nowy Port Szaniec Zachodni 02",
  "128": "Migowo 03",
  "130": "Chełm Cienista 01",
  "132": "Orunia Górna 01",
  "134": "Chełm Cienista 02",
  "135": "Równa 01",
  "137": "Olszynka Szkoła 02",
  "139": "Górki Zachodnie 01",
  "141": "Westerplatte 01",
  "142": "Górki Wschodnie 01",
  "143": "Przegalina 01",
  "146": "Lipuska 01",
  "147": "Bysewo 05",
  "150": "Matemblewo 01",
  "151": "Suchanino 01",
  "153": "Niedźwiednik 01",
  "154": "Oliwa ZOO 01",
  "158": "Sztutowska 01",
  "159": "Jelitkowo 06",
  "160": "Galaktyczna 01",
  "161": "Osowa PKP 03",
  "167": "Chełm Więckowskiego 01",
  "171": "Pruszcz Gdański Komarowo 01",
  "172": "Smęgorzyno 01",
  "173": "Stogi Plaża 03",
  "175": "Św. Wojciech 01",
  "176": "Kukawka 01",
  "178": "Kiełpino Górne 01",
  "183": "Kampinoska 01",
  "184": "Olimpijska 01",
  "191": "Łostowice Świętokrzyska 06",
  "194": "Zakoniczyn 01",
  "195": "Jaworzniaków 01",
  "196": "Żukowo Urząd Gminy 03",
  "199": "Jasień Pólnicy 01",
  "201": "Jelitkowo 02",
  "202": "Oliwa 03",
  "203": "Zaspa 03",
  "204": "Zaspa 04",
  "205": "Siedlce 03",
  "208": "Nowy Port Góreckiego 01",
  "210": "Brzeźno Dom Zdrojowy 01",
  "211": "Strzyża PKM 07",
  "213": "Strzyża PKM 03",
  "220": "Chełm Witosa 01",
  "221": "Łostowice Świętokrzyska 01",
  "310": "Muzeum II Wojny Światowej 01",
  "313": "Wrzeszcz PKP 06",
  "314": "Wrzeszcz PKP 01",
  "321": "Żabianka SKM 01",
  "325": "Nowy Port Szaniec Zachodni 01",
  "334": "Chełm Cienista 03",
  "342": "Górki Wschodnie 02",
  "359": "Jelitkowo 05",
  "390": "Łostowice Świętokrzyska 04",
  "1000": "Plac Solidarności 03",
  "1001": "Aksamitna 01",
  "1002": "Rybaki Górne 01",
  "1004": "Toruńska 01",
  "1006": "Łagiewniki 01",
  "1009": "Plac Solidarności 04",
  "1011": "Plac Komorowskiego 03",
  "1013": "Dworzec Główny 18",
  "1014": "Dworzec Główny 05",
  "1015": "Dworzec Główny 14",
  "1016": "Dworzec Główny 07",
  "1017": "Dworzec Główny 12",
  "1019": "Dworzec Główny 10",
  "1020": "Dworzec Główny 11",
  "1021": "Dworzec Główny 08",
  "1022": "Dworzec Główny 13",
  "1023": "Dworzec Główny 06",
  "1024": "Tamka 01",
  "1025": "Hucisko 04",
  "1026": "Hucisko 03",
  "1028": "Brama Wyżynna 05",
  "1029": "Chłodna 01",
  "1030": "Brama Wyżynna 03",
  "1031": "Cygańska Góra 03",
  "1032": "Cygańska Góra 04",
  "1033": "Brama Wyżynna 04",
  "1035": "Pomorskie Szkoły Rzemiosł 04",
  "1036": "Chłodna 02",
  "1037": "Żabi Kruk 04",
  "1038": "Żabi Kruk 03",
  "1041": "Długie Ogrody 01",
  "1042": "Brama Żuławska 03",
  "1043": "Bajki 01",
  "1044": "Elbląska 05",
  "1045": "Dickensa 01",
  "1046": "Andruszkiewicza 03",
  "1047": "Kaczeńce - Sienna 01",
  "1048": "Wawelska 01",
  "1049": "Wawelska 02",
  "1050": "Sucharskiego 03",
  "1051": "Królowej Bony 02",
  "1052": "Królowej Bony 01",
  "1053": "Sówki 01",
  "1054": "Stogi 06",
  "1055": "Steczka 01",
  "1056": "Sówki 02",
  "1057": "Kępna 01",
  "1058": "Steczka 02",
  "1059": "Baza Manipulacyjna 01",
  "1060": "Kępna 02",
  "1061": "Łęczycka 01",
  "1062": "Baza Manipulacyjna 02",
  "1063": "Łowicka 01",
  "1064": "Łęczycka 02",
  "1065": "Wosia Budzysza 01",
  "1066": "Łowicka 02",
  "1069": "Sucharskiego - PKP 01",
  "1070": "Sucharskiego - PKP 02",
  "1072": "Ku Ujściu 02",
  "1079": "Przystań Żeglugi 01",
  "1080": "Przystań Żeglugi 02",
  "1081": "Ku Ujściu 03",
  "1082": "Ku Ujściu 04",
  "1083": "Borska 01",
  "1085": "Brodnicka 01",
  "1086": "Brodnicka 02",
  "1087": "Europejskie Centrum Solidarności 01",
  "1088": "Żarnowiecka 02",
  "1089": "Siennicka 01",
  "1090": "Siennicka 02",
  "1091": "Przetoczna 01",
  "1092": "Przetoczna 02",
  "1093": "Przejazd Kolejowy 01",
  "1094": "Przejazd Kolejowy 02",
  "1097": "Kujawska 01",
  "1098": "Kujawska 02",
  "1099": "Brama Żuławska 04",
  "1100": "Mostek 01",
  "1101": "Miałki Szlak 02",
  "1102": "Miałki Szlak 01",
  "1103": "Węzeł Elbląska 02",
  "1104": "Błonia 01",
  "1105": "Błonia 02",
  "1106": "Tarcice 01",
  "1107": "Tarcice 02",
  "1108": "Michałki 01",
  "1109": "Michałki 02",
  "1110": "Rafineria 01",
  "1111": "Rafineria 02",
  "1112": "Rejenta 02",
  "1113": "Rejenta 01",
  "1114": "Zosi 02",
  "1115": "Zosi 01",
  "1116": "Domeyki 01",
  "1117": "Świtezianki 02",
  "1118": "Soplicy 01",
  "1119": "Soplicy 02",
  "1120": "Chrobrego 02",
  "1121": "Chrobrego 01",
  "1122": "Ostroroga 01",
  "1123": "Klonowicza 01",
  "1124": "Klonowicza 02",
  "1125": "Leszczyńskich 03",
  "1126": "Meissnera 01",
  "1127": "Meissnera 02",
  "1128": "Olsztyńska 03",
  "1129": "Olsztyńska 04",
  "1130": "Sobieszewo 01",
  "1131": "Radosna 01",
  "1132": "Kanałowa 01",
  "1133": "Kanałowa 02",
  "1134": "Pole Namiotowe 01",
  "1135": "Pole Namiotowe 02",
  "1136": "Lazurowa 01",
  "1137": "Lazurowa 02",
  "1138": "Orlinki 01",
  "1139": "Orlinki 02",
  "1140": "Kwiatowa 01",
  "1141": "Kwiatowa 02",
  "1142": "Trałowa Szkoła 01",
  "1143": "Trałowa Szkoła 02",
  "1144": "Kempingowa 01",
  "1145": "Kempingowa 02",
  "1146": "Węgorzowa 01",
  "1147": "Węgorzowa 02",
  "1148": "Przystań 01",
  "1149": "Przystań 02",
  "1150": "Świbnieńska I 01",
  "1151": "Świbnieńska I 02",
  "1152": "Uzdrowiskowa 01",
  "1153": "Uzdrowiskowa 02",
  "1154": "Świbnieńska III 01",
  "1155": "Świbnieńska III 02",
  "1156": "Przegalińska 01",
  "1157": "Przegalińska 02",
  "1158": "Benzynowa 01",
  "1159": "Benzynowa 02",
  "1160": "Oczyszczalnia 01",
  "1161": "Oczyszczalnia 02",
  "1162": "Naftowa 01",
  "1163": "Naftowa 02",
  "1164": "Płońska 01",
  "1165": "Płońska 02",
  "1166": "Zagroble 01",
  "1167": "Zagroble 02",
  "1168": "Migdałowa 02",
  "1169": "Migdałowa 01",
  "1170": "Cedrowa 02",
  "1171": "Cedrowa 01",
  "1172": "Nowa Gdańska 02",
  "1173": "Nowa Gdańska 01",
  "1174": "Jodowa 01",
  "1175": "Jodowa 02",
  "1176": "Tęczowa 01",
  "1177": "Tęczowa 02",
  "1178": "Nadwiślańska 01",
  "1179": "Nadwiślańska 02",
  "1180": "Ornitologów 01",
  "1181": "Ornitologów 02",
  "1183": "Sierpowa 01",
  "1184": "Bratki 01",
  "1185": "Gęsia 01",
  "1186": "Olszynka Niwki 01",
  "1187": "Zawodzie 01",
  "1188": "Maki 01",
  "1192": "Dolna 01",
  "1193": "Wróbla 01",
  "1194": "Urząd Wojewódzki / Marszałkowski 01",
  "1195": "Urząd Wojewódzki / Marszałkowski 02",
  "1196": "Brama Nizinna 01",
  "1197": "Brama Nizinna 02",
  "1198": "Mostowa 01",
  "1199": "Mostowa 02",
  "1200": "Zaroślak 01",
  "1201": "Zaroślak 02",
  "1202": "Brama Oruńska 01",
  "1203": "Brama Oruńska 02",
  "1204": "Stare Szkoty 01",
  "1205": "Stare Szkoty 02",
  "1206": "Sandomierska 01",
  "1207": "Sandomierska 02",
  "1208": "Rejtana 01",
  "1209": "Rejtana 02",
  "1210": "Gościnna 01",
  "1211": "Gościnna 02",
  "1212": "Nowiny 01",
  "1213": "Nowiny 02",
  "1214": "Urząd Dozoru Technicznego 01",
  "1215": "Ukośna 02",
  "1216": "Ukośna 01",
  "1217": "Niegowska 02",
  "1218": "Niegowska 01",
  "1219": "Węzeł Lipce 02",
  "1220": "Kokoszki PKP 01",
  "1221": "Ostróżek 02",
  "1222": "Ostróżek 01",
  "1223": "Św. Wojciech 02",
  "1227": "Ptasia 02",
  "1228": "Ptasia 01",
  "1229": "Małomiejska 02",
  "1230": "Małomiejska 01",
  "1231": "Platynowa 03",
  "1232": "Platynowa 01",
  "1233": "Uranowa 01",
  "1234": "Dom Pomocy Społecznej 01",
  "1235": "Dom Pomocy Społecznej 02",
  "1236": "Zaroślak 03",
  "1237": "Zaroślak 04",
  "1238": "Cmentarna 01",
  "1239": "Stoczniowców 02",
  "1240": "Reformacka 01",
  "1241": "Wronki 01",
  "1243": "Kokoszki PKP 02",
  "1244": "Rondo Kuronia 01",
  "1245": "Rondo Kuronia 02",
  "1246": "Cieszyńskiego 03",
  "1247": "Sikorskiego 03",
  "1248": "Pohulanka 03",
  "1249": "Pohulanka 04",
  "1250": "Odrzańska 03",
  "1251": "Odrzańska 04",
  "1252": "Worcella 01",
  "1253": "Drwęcka 01",
  "1254": "Chałubińskiego 03",
  "1255": "Chałubińskiego 04",
  "1256": "Węzeł Elbląska 01",
  "1257": "Dworzec PKS 03",
  "1260": "Urząd Miejski 02",
  "1261": "Bema 01",
  "1262": "Zakopiańska 04",
  "1263": "Zakopiańska 03",
  "1264": "Emaus 01",
  "1265": "Siedlce 06",
  "1266": "Zielony Stok 01",
  "1267": "Zielony Stok 02",
  "1268": "Pagórkowa 01",
  "1269": "Pagórkowa 02",
  "1270": "Myśliwska 01",
  "1271": "Myśliwska 02",
  "1272": "Lipowa 01",
  "1273": "Lipowa 02",
  "1274": "Damroki 01",
  "1275": "Damroki 02",
  "1277": "Źródlana 02",
  "1278": "Jasień Działki 01",
  "1279": "Jasień Działki 02",
  "1280": "Węzeł Karczemki 01",
  "1281": "Węzeł Karczemki 02",
  "1282": "Karczemki 01",
  "1283": "Karczemki 02",
  "1284": "Inżynierska 01",
  "1285": "Inżynierska 02",
  "1286": "Fabryczna 01",
  "1287": "Kokoszki 02",
  "1288": "Transportowców 01",
  "1289": "Transportowców 02",
  "1290": "Nowatorów 03",
  "1291": "Nowatorów 02",
  "1292": "Kokoszki Poczta 01",
  "1293": "Kokoszki Poczta 02",
  "1295": "Pólnicy 02",
  "1296": "Unimor 01",
  "1297": "Unimor 02",
  "1298": "Centrostal 01",
  "1299": "Centrostal 02",
  "1300": "Schronisko dla zwierząt \"Promyk\" 01",
  "1301": "Instal 02",
  "1302": "Otomińska 01",
  "1303": "Schronisko dla zwierząt \"Promyk\" 02",
  "1304": "Kiełpino Szkoła 01",
  "1305": "Otomińska 02",
  "1306": "Lawendowe Wzgórze 03",
  "1307": "Kiełpino Szkoła 02",
  "1308": "Szkoła Podstawowa nr 6 01",
  "1309": "Emaus 03",
  "1310": "Cmentarz Łostowicki 02",
  "1311": "Cmentarz Łostowicki 01",
  "1312": "Kielecka 01",
  "1313": "Kielecka 02",
  "1314": "Przemyska 03",
  "1315": "Przemyska 06",
  "1316": "Płocka 03",
  "1317": "Płocka 04",
  "1318": "Orląt Lwowskich 01",
  "1319": "Orląt Lwowskich 02",
  "1320": "Niepołomicka 01",
  "1321": "Niepołomicka 02",
  "1322": "Przebiśniegowa 01",
  "1323": "Przebiśniegowa 02",
  "1324": "Przemian 01",
  "1325": "Przemian 02",
  "1326": "Starogardzka 04",
  "1327": "Starogardzka 01",
  "1328": "Hevelianum 01",
  "1329": "Hevelianum 02",
  "1330": "Płowce 01",
  "1331": "Płowce 02",
  "1332": "Wyczółkowskiego 01",
  "1333": "Wyczółkowskiego 02",
  "1334": "Wagnera 01",
  "1335": "Wagnera 02",
  "1336": "Otwarta 01",
  "1337": "Otwarta 02",
  "1338": "Kurpińskiego 01",
  "1339": "Kurpińskiego 02",
  "1340": "Nad Jarem 01",
  "1341": "Kielecka 03",
  "1342": "Wileńska 01",
  "1343": "Park Naukowo - Technologiczny 01",
  "1344": "Park Naukowo - Technologiczny 02",
  "1345": "Jaśkowa Dolina 05",
  "1346": "Nowolipie 01",
  "1347": "Matejki 02",
  "1348": "Uphagena 01",
  "1349": "Siedlicka 02",
  "1350": "Siedlicka 01",
  "1351": "Kręta 02",
  "1352": "Kręta 01",
  "1353": "Jarowa 02",
  "1354": "Jarowa 01",
  "1355": "Pomorskie Szkoły Rzemiosł 02",
  "1356": "Pomorskie Szkoły Rzemiosł 01",
  "1357": "Schumana 02",
  "1358": "Schumana 01",
  "1359": "Schuberta 02",
  "1360": "Schuberta 01",
  "1361": "Na Wzgórzu - Teatr Leśny 02",
  "1362": "Sobótki 01",
  "1363": "Falista 02",
  "1364": "Na Wzgórzu - Teatr Leśny 01",
  "1365": "Strzelnica 02",
  "1366": "Falista 01",
  "1367": "Dobrowolskiego 02",
  "1368": "Strzelnica 01",
  "1369": "Piecewska 02",
  "1370": "Dobrowolskiego 01",
  "1372": "Piecewska 01",
  "1373": "Budapesztańska 04",
  "1376": "Budapesztańska 03",
  "1378": "Brętowo PKM 03",
  "1379": "Brętowo PKM 04",
  "1380": "Kolumba 03",
  "1381": "Kolumba 04",
  "1382": "Galeria Bałtycka 05",
  "1383": "Galeria Bałtycka 06",
  "1385": "Chrzanowskiego 02",
  "1386": "Srebrniki 01",
  "1387": "Srebrniki 02",
  "1388": "Niedźwiednik PKM 03",
  "1389": "Niedźwiednik PKM 02",
  "1390": "Potokowa 01",
  "1391": "Potokowa 02",
  "1392": "Rybacka 01",
  "1393": "Potokowa 03",
  "1394": "Słowackiego Działki 01",
  "1395": "Słowackiego Działki 02",
  "1396": "Harfowa 01",
  "1397": "Harfowa 02",
  "1398": "Agrarna 01",
  "1399": "Agrarna 02",
  "1400": "Astronautów 01",
  "1401": "Astronautów 02",
  "1402": "Firoga PKM 01",
  "1403": "Firoga PKM 02",
  "1404": "Śmigłowa 01",
  "1405": "Wrzeszczańska 01",
  "1406": "Wrzeszczańska 02",
  "1407": "Wojnarskiego 01",
  "1408": "Klukowo 01",
  "1409": "Radiowa 02",
  "1410": "Spadochroniarzy 02",
  "1411": "Agrarna 03",
  "1413": "Nowatorów 04",
  "1414": "Nowatorów 01",
  "1415": "Rakietowa 02",
  "1416": "Rakietowa 01",
  "1417": "Kosmonautów 02",
  "1418": "Kosmonautów 01",
  "1419": "Bysewo 04",
  "1420": "Bysewo 03",
  "1421": "Ogrody Działkowe \"Rębiechowo\" II 02",
  "1422": "Ogrody Działkowe \"Rębiechowo\" II 01",
  "1423": "Ogrody Działkowe \"Rębiechowo\" I 02",
  "1424": "Ogrody Działkowe \"Rębiechowo\" I 01",
  "1425": "Przyrodników 02",
  "1426": "Przyrodników 01",
  "1431": "Potokowa 04",
  "1432": "Chrzanowskiego 01",
  "1433": "Ogrodowa 02",
  "1434": "Ogrodowa 01",
  "1435": "Dolne Młyny 02",
  "1436": "Dolne Młyny 01",
  "1437": "Potokowa - Matemblewska 02",
  "1438": "Potokowa - Matemblewska 01",
  "1439": "Podkarpacka 01",
  "1440": "Podkarpacka 02",
  "1441": "Kilińskiego 02",
  "1442": "Legionów 04",
  "1443": "Kopalniana 01",
  "1444": "Ciołkowskiego 01",
  "1445": "Drzewieckiego 01",
  "1446": "Korczaka 01",
  "1447": "Zaspa Szpital 01",
  "1448": "Czarny Dwór 02",
  "1449": "Grudziądzka 05",
  "1450": "Lwowska 01",
  "1451": "Mickiewicza 01",
  "1452": "Biała 01",
  "1453": "Bora-Komorowskiego 07",
  "1454": "Bora-Komorowskiego 04",
  "1455": "Czerwony Dwór 05",
  "1456": "Czerwony Dwór 04",
  "1457": "Jagiellońska 02",
  "1458": "Jagiellońska 01",
  "1459": "Park Reagana 02",
  "1460": "Park Reagana 01",
  "1461": "Biały Dwór 02",
  "1462": "Biały Dwór 01",
  "1463": "Olsztyńska 02",
  "1464": "Olsztyńska 01",
  "1465": "Opolska 02",
  "1466": "Opolska 01",
  "1467": "Kołobrzeska 06",
  "1468": "Kołobrzeska 05",
  "1469": "Krynicka 02",
  "1470": "Krynicka 01",
  "1471": "Chłopska 01",
  "1472": "Obrońców Wybrzeża 01",
  "1473": "Obrońców Wybrzeża 02",
  "1474": "Przymorze Wielkie 01",
  "1475": "Przymorze Wielkie 02",
  "1476": "Czarny Dwór 01",
  "1477": "Czarny Dwór 03",
  "1478": "Leszczyńskich 01",
  "1479": "Zaspa Szpital 02",
  "1480": "Rzeczypospolitej 01",
  "1481": "Leszczyńskich 02",
  "1482": "Dywizjonu 303 01",
  "1483": "Rzeczypospolitej 02",
  "1484": "Chłopska 02",
  "1485": "Pilotów 01",
  "1487": "Pomorska 04",
  "1488": "Piastowska 05",
  "1489": "Piastowska 06",
  "1490": "Czerwony Dwór 03",
  "1491": "Dworska 03",
  "1492": "Dworska 04",
  "1493": "PCK 01",
  "1494": "PCK 02",
  "1495": "Brzeźno Dom Zdrojowy 05",
  "1496": "Brzeźno Dom Zdrojowy 04",
  "1497": "Zespół Szkół Morskich 01",
  "1498": "Zespół Szkół Morskich 02",
  "1499": "Wyzwolenia 01",
  "1500": "Wyzwolenia 02",
  "1502": "Władysława IV 02",
  "1503": "Stary Rynek Oliwski 02",
  "1504": "Stary Rynek Oliwski 01",
  "1505": "Karwieńska 02",
  "1506": "Karwieńska 01",
  "1507": "Rynarzewo 02",
  "1508": "Rynarzewo 01",
  "1509": "Osowa Obwodnica 02",
  "1510": "Osowa Obwodnica 01",
  "1511": "Sopocka 02",
  "1512": "Sopocka 01",
  "1513": "Nowa 02",
  "1514": "Nowa 01",
  "1515": "Barniewicka 02",
  "1516": "Barniewicka 01",
  "1517": "Niedziałkowskiego 02",
  "1518": "Niedziałkowskiego 01",
  "1519": "Biwakowa 02",
  "1520": "Biwakowa 01",
  "1521": "Osowa PKP 02",
  "1522": "Konstelacji 01",
  "1523": "Nowy Świat 02",
  "1524": "Nowy Świat 01",
  "1525": "Tysiąclecia 02",
  "1526": "Tysiąclecia 01",
  "1527": "Piastowska 04",
  "1528": "Piastowska 03",
  "1529": "Poznańska 02",
  "1530": "Poznańska 01",
  "1532": "Park Oliwski 01",
  "1533": "Oliwa 06",
  "1534": "Oliwa 08",
  "1535": "Sarnia 01",
  "1536": "Cmentarz Oliwski 02",
  "1537": "Bobrowa 01",
  "1538": "Bobrowa 02",
  "1540": "Czyżewskiego 01",
  "1541": "Brama Oliwska 04",
  "1542": "Brama Oliwska 03",
  "1543": "Siemiradzkiego 01",
  "1544": "Siemiradzkiego 02",
  "1545": "Cmentarz Oliwski 01",
  "1546": "Koziorożca 01",
  "1547": "Koziorożca 02",
  "1548": "Zeusa 01",
  "1549": "Zeusa 02",
  "1550": "Konkordii 01",
  "1551": "Konkordii 02",
  "1552": "Archikatedra Oliwska 01",
  "1553": "Jelitkowo Kapliczna 01",
  "1554": "Jelitkowo Kapliczna 02",
  "1555": "Jelitkowo 03",
  "1556": "Jelitkowo 04",
  "1558": "Karczemki 04",
  "1559": "Startowa 03",
  "1560": "Startowa 04",
  "1561": "Karczemki Szkoła 01",
  "1562": "Karczemki Szkoła 02",
  "1563": "Maciejkowa 01",
  "1564": "Maciejkowa 02",
  "1565": "Św. Brata Alberta 01",
  "1566": "Św. Brata Alberta 02",
  "1567": "Fundamentowa 01",
  "1568": "Montażystów 02",
  "1569": "Barniewicka 03",
  "1570": "Pomorska - Osiedle 03",
  "1571": "Iławska 02",
  "1572": "Iławska 01",
  "1573": "Myśliborska 02",
  "1574": "Myśliborska 01",
  "1575": "Siedleckiego 02",
  "1576": "Siedleckiego 01",
  "1577": "Sołdka 02",
  "1578": "Sołdka 01",
  "1579": "Krzemowa 01",
  "1580": "al. Płażyńskiego 06",
  "1581": "Sopocka 03",
  "1582": "Bratki 02",
  "1583": "Montażystów 01",
  "1584": "Bluszczowa 01",
  "1585": "Doroszewskiego 01",
  "1586": "Doroszewskiego 02",
  "1588": "Norblina 02",
  "1589": "Krasickiego 04",
  "1590": "Krasickiego 03",
  "1592": "Plac Wolności 02",
  "1593": "Jaśkowa Dolina 04",
  "1594": "Jaśkowa Dolina 03",
  "1595": "Teatr Miniatura / Radio Gdańsk 04",
  "1596": "Teatr Miniatura / Radio Gdańsk 03",
  "1597": "Opera Bałtycka 04",
  "1598": "Opera Bałtycka 05",
  "1599": "Uniwersytet Medyczny 04",
  "1600": "Uniwersytet Medyczny 03",
  "1601": "Mostek 02",
  "1602": "Kościuszki 05",
  "1606": "Łanowa II 01",
  "1607": "Wilka-Krzyżanowskiego 04",
  "1608": "Wilka-Krzyżanowskiego 03",
  "1609": "Wyspiańskiego 04",
  "1610": "Złota Karczma 02",
  "1611": "Mjr Słabego 02",
  "1613": "Kołobrzeska 03",
  "1614": "Kołobrzeska 04",
  "1616": "Żwirki i Wigury 03",
  "1617": "Kościuszki 04",
  "1618": "Legionów 03",
  "1619": "Obrońców Westerplatte 04",
  "1620": "Kościuszki 03",
  "1621": "Bażyńskiego 04",
  "1622": "Obrońców Westerplatte 03",
  "1623": "Uniwersytet Gdański 04",
  "1624": "Swojska 05",
  "1625": "Strzyża PKM 04",
  "1626": "Uniwersytet Gdański 03",
  "1627": "Zamenhofa 04",
  "1628": "Strzyża PKM 05",
  "1629": "Wojska Polskiego 04",
  "1630": "Zamenhofa 03",
  "1631": "Galeria Bałtycka 04",
  "1632": "Wojska Polskiego 05",
  "1633": "Emaus 04",
  "1634": "Galeria Bałtycka 07",
  "1635": "Emaus 02",
  "1636": "Galeria Bałtycka 03",
  "1637": "Sopocka 04",
  "1638": "Jednorożca 01",
  "1639": "Jednorożca 02",
  "1640": "Marynarki Polskiej 05",
  "1641": "Marynarki Polskiej 04",
  "1642": "Śnieżna 03",
  "1643": "Śnieżna 04",
  "1644": "Polsat Plus Arena Gdańsk 03",
  "1645": "Polsat Plus Arena Gdańsk 04",
  "1646": "Swojska 03",
  "1647": "Swojska 04",
  "1648": "Stocznia Północna 03",
  "1649": "Stocznia Północna 04",
  "1650": "Grudziądzka 03",
  "1651": "Korczaka 02",
  "1652": "Wyspiańskiego 03",
  "1653": "Drzewieckiego 02",
  "1654": "Mickiewicza 05",
  "1655": "Mickiewicza 04",
  "1656": "Świbnieńska II 01",
  "1657": "Świbnieńska II 02",
  "1658": "Bysewo 01",
  "1659": "Bysewo 02",
  "1660": "Dworkowa 01",
  "1661": "Akademia Muzyczna 04",
  "1662": "Akademia Muzyczna 03",
  "1664": "Kamienna Grobla 01",
  "1665": "Opacka 04",
  "1666": "Opacka 03",
  "1667": "Górskiego 02",
  "1668": "Górskiego 01",
  "1669": "Nadwodna 01",
  "1670": "Pólnicy 01",
  "1671": "Przesypownia 02",
  "1672": "Jeziorowa 02",
  "1673": "Jeziorowa 01",
  "1674": "Szczecińska 01",
  "1675": "Szczecińska 02",
  "1676": "Jaworowa 02",
  "1677": "Jaworowa 01",
  "1680": "Boguckiego 01",
  "1681": "Boguckiego 02",
  "1682": "Dobra 01",
  "1683": "Miałki Szlak 03",
  "1684": "Szadółki 01",
  "1685": "Szadółki 02",
  "1686": "Przywidzka 01",
  "1687": "Przywidzka 02",
  "1689": "Na Szańcach 02",
  "1690": "Politechnika SKM 04",
  "1691": "Politechnika SKM 03",
  "1692": "Sucharskiego 04",
  "1693": "Stokrotki 02",
  "1697": "Grzybowa 02",
  "1698": "Grzybowa 01",
  "1703": "Kokoszki 01",
  "1704": "Kopeckiego 01",
  "1705": "Łanowa I 01",
  "1706": "Łanowa III 01",
  "1707": "Łanowa IV 01",
  "1712": "Łucznicza 01",
  "1713": "Łucznicza 02",
  "1714": "Bursztynowa 02",
  "1715": "Bursztynowa 01",
  "1716": "Oliwa PKP 01",
  "1717": "Cieszyńskiego 04",
  "1718": "Oliwa PKP 05",
  "1719": "Życzliwa 02",
  "1720": "Życzliwa 01",
  "1721": "Gostyńska Szpital 02",
  "1722": "Gostyńska Szpital 01",
  "1723": "Piekarnicza 03",
  "1724": "Piekarnicza 04",
  "1725": "Sobótki 02",
  "1726": "Belgradzka 03",
  "1727": "SDO \"Złota Jesień\" 01",
  "1728": "Skarżyńskiego 01",
  "1729": "Chopina 01",
  "1730": "Odyseusza 01",
  "1731": "Terminal - Cargo 02",
  "1732": "Terminal - Cargo 01",
  "1733": "Śmigłowa 02",
  "1734": "Platynowa 02",
  "1735": "Karskiego 02",
  "1736": "Karskiego 01",
  "1737": "Skarżyńskiego 02",
  "1739": "Kilińskiego 01",
  "1740": "Beniowskiego 01",
  "1741": "Beniowskiego 02",
  "1742": "Świętokrzyska 02",
  "1743": "Świętokrzyska 01",
  "1745": "Góralska 01",
  "1746": "Góralska 02",
  "1747": "Spadochroniarzy 01",
  "1748": "Kopeckiego 02",
  "1749": "Radiowa 01",
  "1750": "Ogrody Działkowe \"Rębiechowo\" III 01",
  "1751": "Ogrody Działkowe \"Rębiechowo\" III 02",
  "1752": "Zaspa SKM 01",
  "1753": "Sikorskiego 05",
  "1754": "Rozstaje 05",
  "1755": "Rozstaje 04",
  "1756": "Srebrna 01",
  "1757": "Srebrna 02",
  "1758": "Falowa 01",
  "1759": "Falowa 02",
  "1760": "Stokrotki 01",
  "1761": "Gospody 01",
  "1762": "Pomorska 03",
  "1763": "Sobieszewska 02",
  "1764": "Sobieszewska 01",
  "1765": "Oriona 02",
  "1766": "Oriona 01",
  "1767": "Hynka 02",
  "1768": "Hynka 01",
  "1769": "Olszyńska 02",
  "1770": "Olszyńska 01",
  "1771": "Przybrzeżna 03",
  "1772": "Kolonia Mysia 01",
  "1773": "Kolonia Mysia 02",
  "1774": "Głucha 01",
  "1775": "Głucha 02",
  "1776": "Gronostajowa 91",
  "1777": "Migowo 04",
  "1778": "Oliwa 05",
  "1779": "Oliwa 04",
  "1780": "Sikorskiego 04",
  "1781": "Saturna 02",
  "1782": "Saturna 01",
  "1783": "Maćkowy 01",
  "1784": "Maćkowy 02",
  "1785": "Keplera 02",
  "1786": "Keplera 01",
  "1787": "Wodnika 02",
  "1788": "Wodnika 01",
  "1789": "Wieżycka 02",
  "1790": "Wieżycka 01",
  "1791": "Przymorze SKM 02",
  "1792": "Przymorze SKM 01",
  "1793": "Abrahama 02",
  "1794": "Abrahama 01",
  "1795": "Karczemki 03",
  "1796": "Wojska Polskiego 03",
  "1797": "Łapińska 02",
  "1798": "Łapińska 01",
  "1799": "Liliowa 02",
  "1800": "Liliowa 01",
  "1802": "Złota Karczma 01",
  "1803": "Szadółki Obwodnica 02",
  "1804": "Szadółki Obwodnica 01",
  "1805": "Lubowidzka 02",
  "1806": "Lubowidzka 01",
  "1807": "Potęgowska 02",
  "1808": "Potęgowska 01",
  "1809": "Połczyńska 02",
  "1810": "Połczyńska 01",
  "1811": "Dębinki 01",
  "1825": "Reymonta 01",
  "1826": "Bajana 03",
  "1827": "Forsycji 02",
  "1828": "Forsycji 01",
  "1832": "Targ Drzewny 01",
  "1833": "Obrońców Westerplatte 05",
  "1834": "Targ Chlebowy 01",
  "1835": "Żuraw 01",
  "1836": "Katarzynki 01",
  "1837": "Heweliusza 01",
  "1838": "Miedza 02",
  "1840": "Hala \"Olivia\" 01",
  "1842": "Turystyczna 01",
  "1843": "Turystyczna 02",
  "1844": "Sąsiedzka 01",
  "1845": "Sąsiedzka 02",
  "1846": "Nad Jarem 02",
  "1847": "Suchanino 02",
  "1848": "Wołkowyska 01",
  "1849": "Wołkowyska 02",
  "1850": "Zacna 01",
  "1851": "Zacna 02",
  "1852": "Przywidzka 03",
  "1853": "Staw Wróbla 02",
  "1854": "Czermińskiego 01",
  "1856": "Szmaragdowa 01",
  "1859": "Knyszyńska 01",
  "1860": "Srebrna 03",
  "1861": "Osiedle Jary 02",
  "1862": "Osiedle Jary 01",
  "1863": "Rogalińska 02",
  "1864": "Rogalińska 01",
  "1865": "Płocka 06",
  "1866": "Płocka 05",
  "1867": "Smoluchowskiego 02",
  "1868": "Smoluchowskiego 01",
  "1869": "Miedza 01",
  "1870": "Zagony 01",
  "1872": "Staw Wróbla 01",
  "1877": "Dambka 02",
  "1878": "Milskiego 01",
  "1882": "Olimpijska 02",
  "1883": "Marsa 02",
  "1884": "Marsa 01",
  "1885": "Owczarnia 02",
  "1886": "Owczarnia 01",
  "1887": "Klukowo 04",
  "1888": "Klukowo 03",
  "1889": "Kontenerowa 02",
  "1893": "Marynarki Polskiej 03",
  "1894": "Bażyńskiego 05",
  "1895": "Bora-Komorowskiego 06",
  "1896": "Bora-Komorowskiego 05",
  "1898": "Kontenerowa 01",
  "1900": "Terminal DCT 01",
  "1901": "Hokejowa 02",
  "1902": "Hokejowa 01",
  "1905": "Telewizyjna 02",
  "1906": "Telewizyjna 01",
  "1908": "Zakład Utylizacyjny 01",
  "1909": "Zbieżna 02",
  "1910": "Grudziądzka 04",
  "1912": "Opera Bałtycka 06",
  "1913": "Centrum Onkologii 04",
  "1914": "Traugutta 03",
  "1915": "Uniwersyteckie Centrum Kliniczne 02",
  "1916": "Szpital Zakaźny 01",
  "1917": "Szpital Zakaźny 02",
  "1918": "Radarowa 02",
  "1919": "Radarowa 01",
  "1920": "Centrum Medycyny Inwazyjnej 01",
  "1921": "Centrum Medycyny Inwazyjnej 02",
  "1922": "Zabytkowa 01",
  "1923": "Zabytkowa 02",
  "1924": "Cmentarz Srebrzysko 01",
  "1925": "Cmentarz Srebrzysko 02",
  "1926": "Niedźwiednik PKM 01",
  "1927": "Chrzanowskiego 03",
  "1928": "Przytulna 02",
  "1929": "Przytulna 01",
  "1930": "Szczęśliwa 02",
  "1931": "Szczęśliwa 01",
  "1932": "Porębskiego 02",
  "1933": "Porębskiego 01",
  "1934": "Kiełpinek 01",
  "1935": "Kiełpinek 02",
  "1936": "Przegalińska Schronisko 01",
  "1937": "Przegalińska Schronisko 02",
  "1938": "Dulkowa 01",
  "1939": "Dulkowa 02",
  "1940": "Komary 01",
  "1941": "Komary 02",
  "1942": "Sobieszewska Pastwa 2 01",
  "1943": "Sobieszewska Pastwa 2 02",
  "1944": "Marynarska 01",
  "1945": "Marynarska 02",
  "1946": "Sobieszewska Pastwa 1 01",
  "1947": "Sobieszewska Pastwa 1 02",
  "1950": "Wieniecka 01",
  "1951": "Wieniecka 02",
  "1952": "Sobieszewko 01",
  "1953": "Sobieszewko 02",
  "1954": "Sobieszewko Ośrodek 01",
  "1955": "Sobieszewko Ośrodek 02",
  "1956": "Osiedle Świętokrzyskie 02",
  "1957": "Osiedle Świętokrzyskie 01",
  "1958": "Osiedle Świętokrzyskie 03",
  "1959": "Elfów 01",
  "1960": "Elfów 02",
  "1961": "Baśniowa 02",
  "1962": "Baśniowa 01",
  "1963": "Rębowo 02",
  "1964": "Rębowo 01",
  "1965": "Czermińskiego 02",
  "1968": "Leszczynowa 01",
  "1969": "Leszczynowa 02",
  "1970": "Jabłoniowa Osiedle 01",
  "1971": "Jabłoniowa Osiedle 02",
  "1979": "Wilanowska 04",
  "1980": "Wilanowska 03",
  "1981": "Przemyska 05",
  "1983": "Piotrkowska 04",
  "1984": "Jeleniogórska 01",
  "1985": "Jeleniogórska 02",
  "1991": "AmberExpo 01",
  "1992": "AmberExpo 02",
  "1993": "Żaglowa - AmberExpo 04",
  "1994": "Żaglowa - AmberExpo 03",
  "1996": "Uczniowska 02",
  "1997": "al. Płażyńskiego 04",
  "1998": "al. Płażyńskiego 03",
  "1999": "al. Płażyńskiego 05",
  "2001": "Dworzec Główny 01",
  "2002": "Dworzec Główny 02",
  "2005": "Brama Oliwska 01",
  "2006": "Brama Oliwska 02",
  "2007": "Chodowieckiego 01",
  "2008": "Chodowieckiego 02",
  "2009": "Uniwersytet Medyczny 01",
  "2010": "Uniwersytet Medyczny 02",
  "2011": "Traugutta 01",
  "2012": "Traugutta 02",
  "2013": "Opera Bałtycka 03",
  "2014": "Opera Bałtycka 02",
  "2015": "Opera Bałtycka 01",
  "2016": "Politechnika 02",
  "2017": "Politechnika 01",
  "2018": "Miszewskiego 02",
  "2019": "Miszewskiego 01",
  "2020": "Jaśkowa Dolina 02",
  "2021": "Jaśkowa Dolina 01",
  "2022": "Klonowa 02",
  "2023": "Klonowa 01",
  "2024": "Galeria Bałtycka 02",
  "2025": "Galeria Bałtycka 01",
  "2026": "Wojska Polskiego 02",
  "2027": "Wojska Polskiego 01",
  "2028": "Zamenhofa 02",
  "2029": "Zamenhofa 01",
  "2030": "Wilka-Krzyżanowskiego 02",
  "2031": "Wilka-Krzyżanowskiego 01",
  "2033": "Strzyża PKM 01",
  "2034": "Strzyża PKM 02",
  "2035": "Uniwersytet Gdański 01",
  "2036": "Uniwersytet Gdański 02",
  "2037": "Bażyńskiego 01",
  "2038": "Bażyńskiego 02",
  "2039": "Tetmajera 01",
  "2040": "Tetmajera 02",
  "2041": "Derdowskiego 01",
  "2042": "Derdowskiego 02",
  "2043": "Obrońców Westerplatte 01",
  "2044": "Obrońców Westerplatte 02",
  "2045": "Oliwa 01",
  "2046": "Oliwa 02",
  "2047": "Opacka 01",
  "2048": "Opacka 02",
  "2049": "Subisława 01",
  "2050": "Subisława 02",
  "2051": "Pomorska - Osiedle 01",
  "2052": "Pomorska - Osiedle 02",
  "2054": "Gospody 02",
  "2055": "Osiedle Wejhera 01",
  "2056": "Osiedle Wejhera 02",
  "2057": "Helska 01",
  "2058": "Helska 02",
  "2061": "Plac Solidarności 01",
  "2062": "Plac Solidarności 02",
  "2063": "Stocznia SKM 01",
  "2064": "Stocznia SKM 02",
  "2065": "Stocznia Północna 01",
  "2066": "Stocznia Północna 02",
  "2067": "Twarda 01",
  "2068": "Twarda 02",
  "2069": "Politechnika SKM 01",
  "2070": "Politechnika SKM 02",
  "2071": "Wyspiańskiego 01",
  "2072": "Wyspiańskiego 02",
  "2073": "Reja 01",
  "2074": "Reja 02",
  "2076": "Mickiewicza 02",
  "2077": "Plac Komorowskiego 01",
  "2078": "Plac Komorowskiego 02",
  "2079": "Legionów 01",
  "2080": "Legionów 02",
  "2081": "Bajana 01",
  "2082": "Bajana 02",
  "2083": "Żwirki i Wigury 01",
  "2084": "Żwirki i Wigury 02",
  "2085": "Jana Pawła II 01",
  "2086": "Jana Pawła II 02",
  "2087": "Startowa 01",
  "2088": "Startowa 02",
  "2089": "Zaspa 01",
  "2090": "Zaspa 02",
  "2091": "Kołobrzeska 01",
  "2092": "Kołobrzeska 02",
  "2093": "Bora-Komorowskiego 01",
  "2094": "Bora-Komorowskiego 02",
  "2095": "Czerwony Dwór 01",
  "2096": "Czerwony Dwór 02",
  "2097": "Piastowska 01",
  "2098": "Piastowska 02",
  "2099": "Pomorska 01",
  "2100": "Pomorska 02",
  "2101": "Brama Wyżynna 02",
  "2102": "Brama Wyżynna 01",
  "2103": "Okopowa 02",
  "2104": "Okopowa 01",
  "2105": "Żabi Kruk 01",
  "2106": "Żabi Kruk 02",
  "2107": "Chmielna 02",
  "2108": "Chmielna 01",
  "2109": "Akademia Muzyczna 02",
  "2110": "Akademia Muzyczna 01",
  "2113": "Brama Żuławska 01",
  "2114": "Brama Żuławska 02",
  "2132": "Nowe Ogrody 02",
  "2133": "Urząd Miejski 01",
  "2135": "Dworzec PKS 01",
  "2136": "Dworzec PKS 02",
  "2137": "Hucisko 02",
  "2138": "Hucisko 01",
  "2139": "Powstańców Warszawskich 02",
  "2140": "Powstańców Warszawskich 01",
  "2141": "Paska 02",
  "2142": "Paska 01",
  "2143": "Ciasna 02",
  "2144": "Ciasna 01",
  "2145": "Zakopiańska 02",
  "2146": "Zakopiańska 01",
  "2147": "Skrajna 02",
  "2148": "Skrajna 01",
  "2149": "Siedlce 02",
  "2150": "Siedlce 01",
  "2153": "Węzeł Kliniczna 01",
  "2154": "Węzeł Kliniczna 02",
  "2155": "Swojska 01",
  "2156": "Swojska 02",
  "2157": "Żaglowa - AmberExpo 02",
  "2158": "Żaglowa - AmberExpo 01",
  "2159": "Mostostal 02",
  "2160": "Mostostal 01",
  "2161": "Polsat Plus Arena Gdańsk 02",
  "2162": "Polsat Plus Arena Gdańsk 01",
  "2163": "Śnieżna 01",
  "2164": "Śnieżna 02",
  "2165": "Marynarki Polskiej 01",
  "2166": "Marynarki Polskiej 02",
  "2169": "Władysława IV 01",
  "2171": "Mickiewicza 03",
  "2172": "Kościuszki 01",
  "2173": "Kościuszki 02",
  "2174": "Kolonia Uroda 01",
  "2175": "Kolonia Uroda 02",
  "2176": "Grudziądzka 01",
  "2177": "Grudziądzka 02",
  "2178": "al. Płażyńskiego 02",
  "2179": "al. Płażyńskiego 01",
  "2181": "Gdańska 01",
  "2183": "Sternicza 01",
  "2184": "Dworska 02",
  "2186": "Wczasy 01",
  "2187": "Uczniowska 01",
  "2188": "Mazurska 01",
  "2189": "Brzeźno Dom Zdrojowy 03",
  "2190": "Brzeźno Dom Zdrojowy 02",
  "2191": "Krasickiego 02",
  "2192": "Krasickiego 01",
  "2193": "Latarnia Morska 01",
  "2194": "Latarnia Morska 02",
  "2195": "Kasztanowa 02",
  "2196": "Kasztanowa 01",
  "2207": "Śródmieście SKM 02",
  "2211": "Pohulanka 02",
  "2212": "Pohulanka 01",
  "2213": "Odrzańska 02",
  "2214": "Odrzańska 01",
  "2215": "Chałubińskiego 02",
  "2216": "Chałubińskiego 01",
  "2217": "Sikorskiego 02",
  "2218": "Sikorskiego 01",
  "2219": "Chełm Witosa 02",
  "2221": "Cieszyńskiego 02",
  "2222": "Cieszyńskiego 01",
  "2223": "Cebertowicza 02",
  "2224": "Cebertowicza 01",
  "2225": "Wilanowska 02",
  "2226": "Wilanowska 01",
  "2227": "Przemyska 02",
  "2228": "Przemyska 01",
  "2229": "Płocka 02",
  "2230": "Płocka 01",
  "2231": "Łostowice Świętokrzyska 02",
  "5225": "Pruszcz Gdański Radunica 02",
  "5226": "Pruszcz Gdański Radunica 01",
  "5600": "Pruszcz Gdański Przemysłowa 03",
  "5601": "Pruszcz Gdański Przemysłowa 02",
  "5602": "Pruszcz Gdański Przemysłowa 01",
  "5603": "Pruszcz Gdański Chopina 02",
  "5604": "Pruszcz Gdański Krótka – Dom Wiedemanna 01",
  "5605": "Pruszcz Gdański Matejki 02",
  "5606": "Pruszcz Gdański Matejki 01",
  "5607": "Pruszcz Gdański Nowowiejskiego 02",
  "5608": "Pruszcz Gdański Nowowiejskiego 01",
  "5609": "Pruszcz Gdański Urząd Skarbowy 01",
  "5701": "Pruszcz Gdański Pogotowie Ratunkowe 01",
  "5702": "Pruszcz Gdański Wojska Polskiego 01",
  "5704": "Pruszcz Gdański Rondo Kaszubskie 02",
  "5811": "Pruszcz Gdański Powstanców Warszawy/Drzymały 04",
  "5812": "Pruszcz Gdański Dąbrowskiego 02",
  "5813": "Pruszcz Gdański Powstańców Warszawy 01",
  "5814": "Pruszcz Gdański Powstańców Warszawy 02",
  "5815": "Pruszcz Gdański Emilii Plater 01",
  "5816": "Pruszcz Gdański Emilii Plater 02",
  "5817": "Pruszcz Gdański Reymonta 01",
  "5818": "Pruszcz Gdański Reymonta 02",
  "5819": "Pruszcz Gdański Osiedle Wschód 01",
  "5820": "Pruszcz Gdański Osiedle Wschód 02",
  "5827": "Pruszcz Gdański Kopernika/Sienkiewicza 19",
  "5828": "Pruszcz Gdański Kopernika/Sienkiewicza 56",
  "5829": "Pruszcz Gdański Chopina/Rondo 21",
  "5830": "Pruszcz Gdański Chopina/Rondo 02",
  "5831": "Pruszcz Gdański Zastawna/Rondo 50",
  "5832": "Pruszcz Gdański Chopina/Waląga 52",
  "5834": "Pruszcz Gdański Batalionów Chłopskich 01",
  "5835": "Pruszcz Gdański Chopina/Żwirki i Wigury 31",
  "5836": "Pruszcz Gdański Obrońców Westerplatte 02",
  "5837": "Pruszcz Gdański Obrońców Westerplatte 01",
  "5838": "Pruszcz Gdański Wiśniewskiego 02",
  "5839": "Pruszcz Gdański Wiśniewskiego 01",
  "5840": "Pruszcz Gdański Osiedle Piastowskie 02",
  "5841": "Pruszcz Gdański Osiedle Piastowskie 01",
  "5869": "Pruszcz Gdański Osiedle Kasprowicza 01",
  "5870": "Pruszcz Gdański Osiedle Kasprowicza 02",
  "5871": "Pruszcz Gdański Chopina/Żwirki i Wigury 02",
  "5873": "Pruszcz Gdański Batalionów Chłopskich 02",
  "5874": "Pruszcz Gdański Fabryczny 01",
  "7427": "Rębiechowo Piaskowa 01",
  "7428": "Rębiechowo Piaskowa 02",
  "7429": "Rębiechowo Rębiechowo PKP 02",
  "7430": "Rębiechowo Rębiechowo PKP 01",
  "7432": "Banino Szkoła 01",
  "7575": "Chwaszczyno Oliwska 02",
  "7576": "Chwaszczyno Oliwska 79",
  "7577": "Chwaszczyno Kaszubska Droga 04",
  "7578": "Chwaszczyno Kaszubska Droga 77",
  "7979": "Banino Szkoła 02",
  "7982": "Banino Pszenna 01",
  "7983": "Banino Pszenna 02",
  "7986": "Miszewo 02",
  "7987": "Miszewo Rolnicza 01",
  "7988": "Miszewo Przodkowska 02",
  "7989": "Miszewo Przodkowska 01",
  "7990": "Małkowo Gdyńska 02",
  "7991": "Małkowo Gdyńska 01",
  "7992": "Żukowo Słoneczna 02",
  "7993": "Żukowo Słoneczna 01",
  "7994": "Żukowo Dworcowa 02",
  "7995": "Żukowo Derdowskiego 01",
  "7997": "Żukowo Dworcowa 01",
  "7998": "Żukowo Urząd Gminy 84",
  "8100": "Gdynia Karwiny Nowowiczlińska 03",
  "8102": "Gdynia Anyżowa 02",
  "8227": "Gdynia Dąbrowa Centrum 04",
  "8228": "Gdynia Kameliowa 02",
  "8229": "Gdynia Paprykowa 02",
  "8230": "Gdynia Szafranowa 02",
  "8231": "Gdynia Leśna Polana 02",
  "8234": "Chwaszczyno Rewerenda 01",
  "8235": "Chwaszczyno Synaka 01",
  "8236": "Chwaszczyno 75",
  "8237": "Chwaszczyno Centrum 02",
  "8239": "Gdynia Rewerenda 01",
  "8244": "Gdynia Leśna Polana 01",
  "8245": "Gdynia Szafranowa 01",
  "8246": "Gdynia Paprykowa 01",
  "8247": "Gdynia Dąbrowa Centrum 01",
  "8248": "Gdynia Anyżowa 01",
  "8249": "Gdynia Kameliowa 01",
  "8250": "Chwaszczyno Wiejska 01",
  "8265": "Gdynia Rdestowa - Leśny Zakątek 02",
  "8308": "Gdynia Karwiny PKM 02",
  "8309": "Gdynia Źródło Marii 02",
  "8313": "Gdynia Myśliwska 02",
  "8337": "Gdynia Nałkowskiej 02",
  "8339": "Gdynia Podleśna 01",
  "9001": "Głęboka 91",
  "14413": "Gościnna 03",
  "14417": "Akademia Muzyczna 94",
  "14423": "Osiedle Barniewice 01",
  "14424": "Chmielna 04",
  "14427": "Subisława 03",
  "14428": "Banino Borowiecka 02",
  "14429": "Pruszcz Gdański Chopina/Waląga 23",
  "14430": "Pastelowa 01",
  "14431": "Pastelowa 02",
  "14432": "Meteorytowa 01",
  "14433": "Dwór Ferberów 01",
  "14442": "Cmentarna 02",
  "14443": "Leśna Góra 01",
  "14444": "Leśna Góra - Przychodnia 01",
  "14445": "Leśna Góra - Przychodnia 02",
  "14446": "Reymonta 02",
  "14447": "Mjr Hubala 02",
  "14448": "Mjr Hubala 01",
  "14451": "Szpital Marynarki Wojennej 02",
  "14453": "Jasia i Małgosi 02",
  "14457": "Pruszcz Gdański Broniewskiego 01",
  "14458": "Pruszcz Gdański Broniewskiego 02",
  "14459": "Meteorytowa 02",
  "14460": "Zajezdnia NOWY PORT T2",
  "14464": "Śródmieście SKM 01",
  "14468": "Górecka 01",
  "14469": "Górecka 02",
  "14470": "Sopot Przylesie 01",
  "14472": "Sopot Okrężna 01",
  "14473": "Sopot Uniwersytet Gdański 01",
  "14474": "Sopot Sikorskiego 01",
  "14476": "Sopot 3 Maja 02",
  "14477": "Sopot Reja 02",
  "14478": "Sopot Smolna 02",
  "14479": "Sopot Kasztanowa 01",
  "14480": "Sopot Smolna 01",
  "14481": "Sopot Reja 01",
  "14482": "Sopot 3 Maja 01",
  "14483": "Sopot Sopot PKP - Niepodległości 01",
  "14484": "Sopot Sikorskiego 04",
  "14485": "Sopot Uniwersytet Gdański 02",
  "14486": "Sopot Okrężna 02",
  "14487": "Sopot Hotel \"Marina\" 01",
  "14488": "Sopot Hestii 01",
  "14489": "Sopot Polna 01",
  "14490": "Sopot Bitwy pod Płowcami 04",
  "14491": "Sopot Władysława IV 02",
  "14492": "Sopot Przylesie 02",
  "14493": "Sopot Sanatorium \"Leśnik\" 01",
  "14494": "Sopot Władysława IV 01",
  "14495": "Sopot Bitwy pod Płowcami 02",
  "14496": "Sopot Polna 02",
  "14497": "Sopot Hestii 02",
  "14498": "Sopot Hotel \"Marina\" 02",
  "14499": "Sopot Przylesie 03",
  "14512": "Sopot 3 Maja 03",
  "14513": "Sopot Bohaterów Monte Cassino 01",
  "14514": "Sopot Goyki 01",
  "14515": "Sopot Malczewskiego 01",
  "14519": "Sopot Brodwino Szkoła 01",
  "14520": "Sopot 23 Marca 02",
  "14521": "Sopot 23 Marca 01",
  "14522": "Focha 02",
  "14523": "Focha 01",
  "14526": "Sopot Sopot PKP - Marynarzy 01",
  "14527": "Sopot Sopot PKP 02",
  "14528": "Źródlana 01",
  "14530": "Pruszcz Gdański Wysockiego 01",
  "14531": "Pruszcz Gdański Wysockiego 02",
  "14532": "Jasieńska 01",
  "14533": "Jasień PKM 01",
  "14534": "Jasieńska 03",
  "14535": "Piekarnicza 02",
  "14536": "Piekarnicza 01",
  "14537": "Belgradzka 02",
  "14538": "Belgradzka 01",
  "14541": "Kolumba 02",
  "14542": "Kolumba 01",
  "14543": "Brętowo PKM 02",
  "14544": "Brętowo PKM 01",
  "14545": "Budapesztańska 02",
  "14546": "Budapesztańska 01",
  "14547": "Migowo 01",
  "14548": "Gronostajowa 02",
  "14549": "Jasieńska 02",
  "14550": "Biblioteka Główna UG 02",
  "14551": "Biblioteka Główna UG 01",
  "14552": "Kiełpinek PKM 02",
  "14553": "Matarnia PKM 02",
  "14554": "Matarnia PKM 01",
  "14555": "Osowa PKP 01",
  "14556": "Siedlce 04",
  "14557": "Siedlce 05",
  "14558": "Sopot Junaków 02",
  "14559": "Sopot Małopolska 02",
  "14560": "Sopot Kolberga 02",
  "14561": "Sopot Brodwino 02",
  "14562": "Rondo Mazowieckiego 02",
  "14563": "Rondo Mazowieckiego 01",
  "14564": "Port Lotniczy 09",
  "14567": "Sopot Sopot PKP - Marynarzy 02",
  "14568": "Pruszcz Gdański Dąbrowskiego 01",
  "14569": "Pruszcz Gdański Faktoria 01",
  "14570": "Pruszcz Gdański Faktoria 02",
  "14572": "Pruszcz Gdański Obrońców Wybrzeża 01",
  "14573": "Pruszcz Gdański Cyprysowa 02",
  "14575": "Pruszcz Gdański Cicha (Cmentarz) 01",
  "14576": "Pruszcz Gdański Cicha (Cmentarz) 02",
  "14577": "Pruszcz Gdański Rondo Kaszubskie 01",
  "14578": "Pruszcz Gdański Osiedle Bursztynowe 02",
  "14579": "Pruszcz Gdański Obrońców Wybrzeża 02",
  "14582": "Banino Borowiecka 01",
  "14583": "Pruszcz Gdański Zastawna 02",
  "14584": "Pruszcz Gdański Zastawna 01",
  "14585": "Jaworzniaków 02",
  "14586": "Pruszcz Gdański Rogozińskiego 01",
  "14587": "Migowo 02",
  "14588": "Pruszcz Gdański Słowackiego 01",
  "14591": "Andruszkiewicza 02",
  "14592": "Andruszkiewicza 01",
  "14598": "Pruszcz Gdański Powstańców Warszawy/Plater 29",
  "14599": "Pruszcz Gdański Powstańców Warszawy/Plater 06",
  "14600": "Pruszcz Gdański Powstańców Warszawy/Gałczyńskiego 27",
  "14601": "Pruszcz Gdański Powstańców Warszawy/Gałczyńskiego 01",
  "14602": "Ku Ujściu 05",
  "14605": "Worcella 02",
  "14609": "Kowale Osiedle Olimp 02",
  "14610": "Kowale Osiedle Olimp 01",
  "14611": "Kowale Osiedle Olimp 03",
  "14612": "Kowale Plac Afrodyty 01",
  "14613": "Kowale Szkoła Metropolitalna 01",
  "14614": "Kowale Starowiejska 02",
  "14615": "Kowale Starowiejska 01",
  "14616": "Kowale Kasztelańska 02",
  "14617": "Kowale Kasztelańska 01",
  "14618": "Kowale Szlachecka 01",
  "14619": "Kowale Szlachecka 02",
  "14620": "Jankowo Conradiego Pętla 01",
  "14621": "Chmielna 03",
  "14622": "Bogatka II 01",
  "14623": "Bogatka II 02",
  "14624": "Bogatka I 01",
  "14625": "Bogatka I 02",
  "14626": "Bogatka III 01",
  "14627": "Bogatka III 02",
  "14628": "Przejazdowo Makro 73",
  "14629": "Przejazdowo Makro 02",
  "14630": "Przejazdowo Makro 04",
  "14631": "Przejazdowo Makro 03",
  "14632": "Przejazdowo Hotel 78",
  "14633": "Przejazdowo Hotel 01",
  "14634": "Przejazdowo Łąkowa 01",
  "14635": "Przejazdowo Łąkowa 02",
  "14636": "Przejazdowo Sezonowa 71",
  "14637": "Przejazdowo Sezonowa 04",
  "14638": "Wiślinka Brzegowa 01",
  "14639": "Wiślinka Brzegowa 02",
  "14640": "Wiślinka Pocztowa 01",
  "14641": "Wiślinka Pocztowa 02",
  "14642": "Wiślinka Sportowa 01",
  "14643": "Wiślinka Sportowa 02",
  "14644": "Wiślinka Piaskowa 10",
  "14645": "Wiślinka Piaskowa 65",
  "14648": "Wiślinka Szkoła 67",
  "14649": "Wiślinka Szkoła 08",
  "14650": "Pruszcz Gdański Kopernika/Azaliowa 58",
  "14651": "Jagiełły 01",
  "14652": "Jagiełły 02",
  "14653": "Jana z Kolna 01",
  "14654": "Węzeł Groddecka 02",
  "14655": "Węzeł Groddecka 01",
  "14662": "Leźnieńska 01",
  "14663": "Stokłosy 02",
  "14665": "Sopot Hospicjum 01",
  "14666": "Pruszcz Gdański Rondo Bursztynowe 02",
  "14667": "Pruszcz Gdański Pogotowie Ratunkowe 02",
  "14673": "Stogi Plaża 04",
  "14680": "Sulmin Trakt Konny 19",
  "14681": "Sulmin Trakt Konny 20",
  "14682": "Sulmin 16",
  "14683": "Sulmin 17",
  "14684": "Niestępowo Sulmińska 01",
  "14685": "Niestępowo Sulmińska 14",
  "14686": "Niestępowo Gdańska 12",
  "14687": "Niestępowo Gdańska 03",
  "14688": "Niestępowo Szkoła 10",
  "14689": "Niestępowo Do Zdroju 08",
  "14690": "Niestępowo Do Zdroju 07",
  "14691": "Stara Piła 09",
  "14693": "Toruńska 02",
  "14694": "Nad Stawem 02",
  "14695": "Legionów 05",
  "14696": "Nad Stawem 01",
  "14697": "Węzeł Kliniczna 05",
  "14698": "Fabryczna 02",
  "14700": "Śródmieście SKM 03",
  "14708": "Borkowo Kasztanowa 01",
  "14709": "Kowale Osiedle Cytrusowe 01",
  "14710": "Kowale Osiedle Cytrusowe 02",
  "14712": "Pomorskie Szkoły Rzemiosł 03",
  "14719": "Topazowa 02",
  "14720": "Topazowa 01",
  "14721": "Kolorowa 01",
  "14722": "Kolorowa 02",
  "14723": "Otomin Dziewicza 01",
  "14724": "Otomin Dziewicza 02",
  "14725": "Otomin Sarnia 01",
  "14726": "Otomin Sarnia 02",
  "14727": "Otomin Słoneczna Pętla 01",
  "14728": "Sulmin Trakt Gdański 01",
  "14729": "Borkowo Topolowa 01",
  "14741": "Sulmin Wrzosowe Wzgórze 15",
  "14742": "Sulmin Wrzosowe Wzgórze 18",
  "14760": "Sopot Kraszewskiego 02",
  "14811": "Pruszcz Gdański Rondo Bursztynowe 01",
  "14812": "Pruszcz Gdański Rotmanka - Rondo 01",
  "14813": "Kaczeńce 04",
  "14814": "Kaczeńce 03",
  "14815": "Królewskie Wzgórze 01",
  "14816": "Królewskie Wzgórze 02",
  "14817": "Łabędzia 02",
  "14818": "Łabędzia 01",
  "14819": "Stolema 01",
  "14820": "Stolema 02",
  "14821": "Zabornia 01",
  "14822": "Zabornia 02",
  "14823": "Zabornia 05",
  "14824": "Zabornia 06",
  "14825": "Lawendowe Wzgórze 01",
  "14827": "Ujeścisko 03",
  "14828": "Ujeścisko 02",
  "14829": "Ujeścisko 01",
  "14830": "Ujeścisko 04",
  "14831": "Ujeścisko 06",
  "14832": "Ujeścisko 05",
  "14833": "Królewskie Wzgórze 03",
  "14834": "Łabędzia 04",
  "14835": "Łabędzia 03",
  "14836": "Stolema 04",
  "14837": "Stolema 03",
  "14838": "Zabornia 04",
  "14839": "Zabornia 03",
  "14844": "Ugory eMOCja 03",
  "14845": "Ugory eMOCja 04",
  "14846": "Pokładowa 92",
  "14847": "Pokładowa 91",
  "14850": "Oczyszczalnia 03",
  "14851": "Ujeścisko 51",
  "14852": "Geodetów 01",
  "14854": "Brama Żuławska 05",
  "14855": "Kłosowa 01",
  "14857": "Pruszcz Gdański Emilii Plater 04",
  "14858": "Europejskie Centrum Solidarności 02",
  "14864": "Maszynowa 01",
  "14867": "Pruszcz Gdański Bohaterów Monte Cassino 01",
  "14868": "Pruszcz Gdański Bohaterów Monte Cassino 02",
  "14869": "Port Lotniczy 04",
  "14876": "Pruszcz Gdański Paderewskiego 02",
  "14877": "Pruszcz Gdański Paderewskiego 01",
  "14878": "Pruszcz Gdański Nałkowskiej 02",
  "14879": "Pruszcz Gdański Nałkowskiej 01",
  "14882": "Pruszcz Gdański Kopernika/Kasprowicza 17",
  "14883": "Pruszcz Gdański Kopernika/Kasprowicza 62",
  "14886": "Pruszcz Gdański Zastawna/Rondo 29",
  "14887": "Będzieszyn Panattoni 01",
  "14891": "Uniwersyteckie Centrum Kliniczne 01",
  "14892": "Szadółki 03",
  "14893": "Szadółki 04",
  "14894": "Stężycka 02",
  "14895": "Stężycka 01",
  "14896": "Łagowska 01",
  "14897": "Łagowska 02",
  "14898": "Kolbudzka 02",
  "14899": "Kolbudzka 01",
  "14900": "Lipuska 02",
  "14905": "Gdynia Rdestowa - Kolonia 04",
  "14910": "Barzychowskiej 01",
  "14913": "Modra I 91",
  "14916": "Nowiny 04",
  "14918": "Brętowo PKM 05",
  "14919": "Owczarnia 03",
  "14920": "Długie Ogrody 02",
  "14924": "Gdynia Rdestowa - Leśny Zakątek 01",
  "14926": "Przegalina 02",
  "14927": "Niedźwiednik 02",
  "14928": "Kiełpino Górne 02",
  "14929": "Podleckiego 01",
  "14930": "Podleckiego 02",
  "14931": "Knyszyńska 02",
  "14932": "Czaple Bysewo 03",
  "14933": "Belgradzka 04",
  "14936": "Chwaszczyno Nytbusz 01",
  "14937": "Chwaszczyno Nytbusz 02",
  "14938": "Chwaszczyno Polna I 01",
  "14939": "Chwaszczyno Polna I 02",
  "14941": "Gdynia Bielińskiego 01",
  "14942": "Gdynia Bielińskiego 02",
  "14943": "Gdynia Rdestowa - Kolonia 01",
  "14944": "Chwaszczyno Synaka 04",
  "14945": "Warneńska 01",
  "14946": "Warneńska 02",
  "14947": "Piotrkowska 03",
  "14950": "Piotrkowska 02",
  "14951": "Piotrkowska 01",
  "14952": "Łódzka 02",
  "14953": "Łódzka 01",
  "14954": "Częstochowska 02",
  "14955": "Częstochowska 01",
  "14956": "Kampinoska 02",
  "14957": "Stokłosy 05",
  "14959": "Kokoszki 03",
  "14960": "Głęboka 01",
  "14962": "Przeróbka 01",
  "14963": "Przeróbka 02",
  "14964": "Lenartowicza 01",
  "14965": "Lenartowicza 02",
  "14966": "Zimna 02",
  "14967": "Zimna 01",
  "14968": "Stogi 01",
  "14969": "Stogi 02",
  "14970": "Rozłogi 02",
  "14971": "Nowosądecka 01",
  "14972": "Nowosądecka 02",
  "14973": "Lawendowe Wzgórze 05",
  "14974": "Lawendowe Wzgórze 04",
  "14975": "Rybaki Górne 02",
  "14976": "Geodetów 02",
  "14977": "Przemyska 04",
  "14978": "Przejazdowo Brzozowa 01",
  "14981": "Tarcice 03",
  "14982": "Plac Wolności 01",
  "14983": "Nowy Port Zajezdnia 01",
  "14984": "Nowy Port Oliwska 01",
  "14985": "Rybołowców 01",
  "14986": "Przychodnia 01",
  "14987": "Na Zaspę 01",
  "14988": "Borkowo Stylowa 01",
  "14989": "Borkowo Stylowa 02",
  "14990": "Borkowo Słoneczna 02",
  "14991": "Borkowo Słoneczna 01",
  "14992": "Borkowo Kasztanowa 02",
  "14993": "Borkowo Szkoła 01",
  "14994": "Borkowo Szkoła 02",
  "14995": "Borkowo Topolowa 02",
  "14996": "Borkowo Skrzyżowanie 01",
  "14997": "Platynowa 04",
  "14998": "Człuchowska 02",
  "14999": "Człuchowska 01",
  "15000": "Bramińskiego 01",
  "15001": "Bramińskiego 02",
  "15002": "Huenefelda 01",
  "15003": "Huenefelda 02",
  "15005": "Pruszcz Gdański Kopernika/Wagnera 98",
  "15017": "Gdynia Karwiny Nowowiczlińska 55",
  "15018": "Gdynia Karwiny Nowowiczlińska 01",
  "15019": "Gdynia Karwiny Nowowiczlińska 04",
  "15020": "Zbiornik Wody Orunia 02",
  "15021": "Budowlanych 01",
  "15022": "Budowlanych 02",
  "15026": "Barzychowskiej 02",
  "15030": "Bogatka Skrzyżowanie 06",
  "15031": "Bogatka Skrzyżowanie 69",
  "15044": "Pruszcz Gdański Batalionów Chłopskich 03",
  "15045": "Pruszcz Gdański Tczewska 01",
  "15047": "Dambka 01",
  "15050": "Norblina 01",
  "15053": "Ciołkowskiego 02",
  "15067": "Brama Żuławska 06",
  "15069": "Stokłosy 06",
  "15077": "Stokłosy 01",
  "15081": "Knyszyńska 03",
  "15082": "Traugutta 04",
  "15083": "Letnica Węzeł Harfa 01",
  "15084": "Sopot Żeromskiego 01",
  "15085": "Sopot Żeromskiego 02",
  "15086": "Sopot Herberta 01",
  "15087": "Sopot Osiedle Mickiewicza 01",
  "15088": "Sopot Sikorskiego 02",
  "15091": "Kurpińskiego 92",
  "15092": "Kurpińskiego 91",
  "30103": "Dąbrowa Centrum 02",
  "30104": "Wiczlińska - Las 02",
  "30105": "Wiczlino Działki II 02",
  "30106": "Wiczlino Działki I 02",
  "30107": "Wiczlińska - Śliska 02",
  "30108": "Gradowa 02",
  "30109": "Wiczlino Skrzyżowanie 02",
  "30110": "Potok Wiczliński 02",
  "30111": "Kmicica 02",
  "30112": "Fregatowa 02",
  "30113": "Wiczlino Niemotowo 02",
  "30114": "Fregatowa 01",
  "30115": "Kmicica 01",
  "30116": "Potok Wiczliński 01",
  "30117": "Wiczlino Skrzyżowanie 03",
  "30118": "Zaruskiego 01",
  "30119": "Kamrowskiego 01",
  "30120": "Chwarzno Polanki 01",
  "30121": "Sokoła 01",
  "30125": "Okrężna II 01",
  "30126": "Okrężna I 01",
  "30127": "Witomino Sosnowa 01",
  "30128": "Uczniowska 01",
  "30129": "Witomino Centrum 02",
  "30130": "Stawna 02",
  "30131": "Witomino Leśniczówka 02",
  "30132": "Stawna 01",
  "30133": "Stawna 04",
  "30134": "Witomino Polna 01",
  "30135": "Długa 01",
  "30136": "Witomino Centrum 03",
  "30137": "Centrum Handlowe 'Riviera' 01",
  "30138": "Centrum Handlowe 'Riviera' 02",
  "30139": "Witomino Centrum 01",
  "30140": "Rolnicza  01",
  "30141": "Węzeł Franciszki Cegielskiej 01",
  "30142": "Cmentarz Witomiński 01",
  "30143": "Poznańska 01",
  "30145": "Witomino Leśniczówka 01",
  "30148": "Węzeł Franciszki Cegielskiej 03",
  "30150": "Chwarzno Sokółka 02",
  "30151": "Chwarzno Sokółka 04",
  "30152": "Amona 01",
  "31001": "Kwiatkowskiego 02",
  "31002": "Turkusowa 01",
  "31003": "Dąbka - Zespół Szkół 01",
  "31004": "Benisławskiego 03",
  "31005": "Stolarska 02",
  "31006": "Białowieska 01",
  "31007": "Benisławskiego 01",
  "31008": "Dąbka - Zielona 02",
  "31009": "Dąbka - Zespół Szkół 02",
  "31010": "Turkusowa 02",
  "31011": "Stare Obłuże 02",
  "31012": "Maciejewicza 02",
  "31013": "Staniewicza 02",
  "31014": "Sikorskiego 02",
  "31015": "Steyera 02",
  "31016": "Pogórze Górne 01",
  "31017": "Czernickiego II 01",
  "31018": "Pogórze Dolne 01",
  "31019": "Żelazna 01",
  "31020": "Żeliwna 01",
  "31021": "Podgórska 01",
  "31022": "Kuśnierska 01",
  "31023": "Kuśnierska 02",
  "31024": "Podgórska 02",
  "31025": "Żeliwna 02",
  "31026": "Żelazna 02",
  "31027": "Baza na Pogórzu Dolnym 01",
  "31028": "Pogórze Dolne 02",
  "31029": "Czernickiego II 02",
  "31030": "Pogórze Górne 02",
  "31031": "Pogórze Górne 06",
  "31032": "Steyera 01",
  "31033": "Sikorskiego 01",
  "31034": "Staniewicza 01",
  "31035": "Maciejewicza 01",
  "31036": "Obłuże Maciejewicza 01",
  "31037": "Stare Obłuże 01",
  "31038": "Kwiatkowskiego 01",
  "31039": "Pogórze Górne 04",
  "31040": "Pogórze Dolne 04",
  "31042": "Pogórze Dolne 03",
  "31043": "Białowieska 02",
  "31045": "Stolarska 01",
  "31046": "Benisławskiego 02",
  "31047": "Obłuże Maciejewicza 03",
  "31048": "Kadmowa 02",
  "31049": "Pogórze Dolne Złota 02",
  "31050": "Pogórze Dolne Złota 01",
  "31051": "Kadmowa 01",
  "31052": "Galeria Szperk 02",
  "31101": "Pogórze - Słowackiego 02",
  "31102": "Pogórze - Majakowskiego 02",
  "31103": "Pogórze - Szkolna 02",
  "31104": "Suchy Dwór - Szkolna 02",
  "31106": "Suchy Dwór - Szkolna 01",
  "31107": "Pogórze - Szkolna 01",
  "31108": "Pogórze - Majakowskiego 01",
  "31109": "Pogórze - Dobke 02",
  "31110": "Pogórze - Herberta 02",
  "31111": "Kosakowo - Urząd Gminy 02",
  "31112": "Pierwoszyno - Staw 02",
  "31113": "Pierwoszyno - Kościół 02",
  "31114": "Mosty - Ogrodowa 04",
  "31115": "Mosty - Szkoła 02",
  "31116": "Mechelinki - Przystań 02",
  "31117": "Mosty - Szkoła 01",
  "31118": "Mosty - Ogrodowa 02",
  "31119": "Rewa - Wrocławska 01",
  "31120": "Rewa - Bosmańska 01",
  "31121": "Rewa - Słoneczna 01",
  "31122": "Rewa - Bursztynowa 01",
  "31123": "Rewa - Słoneczna 02",
  "31124": "Rewa - Bosmańska 02",
  "31125": "Rewa - Wrocławska 02",
  "31126": "Mosty - Ogrodowa 01",
  "31127": "Pierwoszyno - Kościół 01",
  "31128": "Pierwoszyno - Staw 01",
  "31129": "Kosakowo - Krokusowa  02",
  "31130": "Kosakowo - Cmentarz - Brama Główna 01",
  "31131": "Dębogórze - Owocowa 02",
  "31132": "Dębogórze - Słonecznikowa 02",
  "31133": "Dębogórze - Jednostka Wojskowa 02",
  "31134": "Dębogórze - Naftobazy 01",
  "31135": "Kazimierz - Kazimierska 01",
  "31136": "Kazimierz - Rumska 01",
  "31137": "Kazimierz - Rumska 02",
  "31138": "Kazimierz - Kazimierska 02",
  "31139": "Dębogórze - Naftobazy 02",
  "31140": "Dębogórze - Jednostka Wojskowa 01",
  "31141": "Dębogórze - Słonecznikowa 01",
  "31142": "Dębogórze - Owocowa 01",
  "31143": "Kosakowo - Krokusowa  01",
  "31144": "Kosakowo - Urząd Gminy 01",
  "31145": "Pogórze - Herberta 01",
  "31146": "Pogórze - Dobke 01",
  "31147": "Kazimierz - Majowa 01",
  "31148": "Kazimierz - Majowa 02",
  "31149": "Kosakowo - Staw 02",
  "31150": "Kosakowo - Staw 01",
  "31153": "Kosakowo - Tulipanowa 01",
  "31154": "Kosakowo - Tulipanowa 02",
  "31155": "Kosakowo - Cmentarz - Brama Główna 02",
  "31157": "Kosakowo - Cmentarz Komunalny 01",
  "31159": "Mosty - Olchowa 02",
  "31160": "Mosty - Olchowa 01",
  "31161": "Mosty - Wiązowa 02",
  "31162": "Mosty - Wiązowa 01",
  "31163": "Dębogórze - Szkoła 02",
  "31164": "Dębogórze - Szkoła 01",
  "31165": "Dębogórze - Okopowa 02",
  "31166": "Dębogórze - Okopowa 01",
  "31167": "Kosakowo - Kościół 01",
  "31168": "Kosakowo - Kościół 02",
  "31171": "Mosty - Ogrodowa 03",
  "31172": "Suchy Dwór - Świetlica 02",
  "31173": "Suchy Dwór - Kochanowskiego 02",
  "31174": "Suchy Dwór - Necla 02",
  "31175": "Suchy Dwór - Borchardta 01",
  "31176": "Suchy Dwór - Gombrowicza 01",
  "31177": "Pogórze - Pułaskiego 01",
  "31178": "Pogórze - Pułaskiego 02",
  "31181": "Kosakowo - Cmentarz Komunalny 02",
  "31182": "Mosty - Brzozowa 01",
  "31183": "Mosty - Wierzbowa 01",
  "31184": "Mechelinki - Przystań 04",
  "31185": "Mosty - Wierzbowa 02",
  "31186": "Mosty - Brzozowa 02",
  "31187": "Kazimierz - Listopadowa 01",
  "31188": "Dębogórze - Słonecznikowa 04",
  "31189": "Kosakowo - Złote Piaski 01",
  "31201": "Pomorska   02",
  "31202": "Kujawska  01",
  "31203": "25-lecia Solidarności 01",
  "31204": "Dąbrowskiego - Sanktuarium 01",
  "31206": "Dąbrowskiego - Most 01",
  "31207": "Rumia Dworzec PKP 04",
  "31208": "Starowiejska - Poczta 02",
  "31209": "Wybickiego  02",
  "31210": "Derdowskiego - Przychodnia 02",
  "31211": "Derdowskiego - Dębogórska 02",
  "31212": "Klonowa 02",
  "31213": "Osiedle Królewskie 02",
  "31214": "Dębogórze-Wybudowanie - Długa 02",
  "31215": "Dębogórze-Wybudowanie - Leśna 02",
  "31216": "Dębogórze-Wybudowanie - Długa 01",
  "31217": "Osiedle Królewskie 01",
  "31218": "Klonowa 01",
  "31219": "Derdowskiego - Dębogórska 01",
  "31220": "Derdowskiego - Przychodnia 01",
  "31221": "Wybickiego  01",
  "31223": "Konopnickiej 02",
  "31224": "Słowackiego 02",
  "31225": "Rumia Partyzantów 02",
  "31226": "Przyrzeczna 02",
  "31227": "Żołnierzy I Dywizji WP 02",
  "31228": "Kanał Leniwy 02",
  "31229": "Kanał Leniwy 01",
  "31230": "Żołnierzy I Dywizji WP 01",
  "31231": "Przyrzeczna 01",
  "31232": "Rumia Partyzantów 01",
  "31233": "Słowackiego 01",
  "31237": "Ceynowy  02",
  "31238": "Okrzei 04",
  "31239": "Prusa  02",
  "31240": "1 Maja 02",
  "31241": "1 Maja 01",
  "31242": "Prusa  01",
  "31243": "Okrzei 02",
  "31244": "Ceynowy  01",
  "31246": "Starowiejska - Poczta 01",
  "31247": "Rumia Dworzec PKP 07",
  "31248": "Rumia Dworzec PKP 05",
  "31249": "Dąbrowskiego - Most 02",
  "31250": "Dąbrowskiego - Sanktuarium 02",
  "31251": "25-lecia Solidarności 02",
  "31252": "Kujawska  02",
  "31254": "Pomorska   01",
  "31256": "Janowo SKM 02",
  "31257": "Rumia Dworzec PKP 02",
  "31259": "Rumia Dworzec PKP 08",
  "31260": "Rumia Dworzec PKP 03",
  "31261": "Rumia Dworzec PKP 01",
  "31262": "Wierzbowa 02",
  "31263": "Wierzbowa 01",
  "31264": "Żwirki i Wigury  02",
  "31265": "Rondo Jana Pawła II 01",
  "31269": "Rondo Jana Pawła II 02",
  "31270": "Żeromskiego  01",
  "31271": "Żeromskiego  02",
  "31272": "Dębogórze-Wybudowanie - Mostowa 01",
  "31276": "Rumia Partyzantów 04",
  "31282": "Zapolskiej 01",
  "31283": "Kościuszki - Kosynierów 02",
  "31284": "Napierskiego 02",
  "31285": "Partyzantów - Kościuszki 01",
  "31287": "25-lecia Solidarności 03",
  "31288": "Dokerów 02",
  "31290": "Partyzantów - Kościuszki 02",
  "31291": "Napierskiego 01",
  "31292": "Kościuszki - Kosynierów 01",
  "31293": "Zapolskiej 02",
  "31294": "Rumia Dworzec PKP - Towarowa 02",
  "31295": "Strzelecka 02",
  "31301": "Cisowa Granica Miasta 02",
  "31302": "Janowo SKM - Sobieskiego 01",
  "31303": "Sobieskiego - FUO 01",
  "31304": "Górnicza 01",
  "31305": "Urząd Miasta Rumi 01",
  "31306": "Chełmońskiego 02",
  "31307": "CH 'Port Rumia' - Grunwaldzka 02",
  "31309": "Obwodowa 01",
  "31310": "Reda Dworzec PKP 02",
  "31312": "Dolna 01",
  "31313": "CH 'Port Rumia' - Grunwaldzka 01",
  "31314": "Chełmońskiego 01",
  "31315": "Centrum Handlowe 'Port Rumia' 01",
  "31316": "Urząd Miasta Rumi 02",
  "31317": "Sabata - Szkoła 02",
  "31318": "Batorego - Szkoła 02",
  "31319": "Podmokła 01",
  "31320": "Zdrojowa 02",
  "31321": "Rumia Szmelta 04",
  "31322": "Zdrojowa 01",
  "31323": "Porazińskiej 01",
  "31324": "Sabata - Szkoła 01",
  "31325": "Górnicza 02",
  "31326": "Rumia Cmentarz Komunalny 01",
  "31327": "Górnicza 03",
  "31328": "Sobieskiego - FUO 02",
  "31329": "Janowo SKM - Sobieskiego 02",
  "31330": "Cisowa Granica Miasta 01",
  "31331": "Rumia Szmelta 02",
  "31333": "Łężyce - Limbowa 02",
  "31335": "Łężyce - Limbowa 01",
  "31336": "Łężyce 01",
  "31337": "Podmokła 02",
  "31338": "Batorego - Szkoła 01",
  "31340": "Łężyce - Topolowa 02",
  "31341": "Łężyce - Topolowa 01",
  "31342": "Reda Dworzec PKP 01",
  "31343": "Gdańska - Kościół 01",
  "31344": "SKM Pieleszewo 01",
  "31345": "Ceynowy SKM Śmiechowo 01",
  "31346": "Rybacka 01",
  "31347": "Kochanowskiego SKM Nanice 01",
  "31348": "Pruszkowskiego 01",
  "31349": "Wejherowo Szpital 02",
  "31350": "Kusocińskiego  02",
  "31351": "Kochanowskiego SKM Nanice 02",
  "31352": "Kociewska SKM Nanice 02",
  "31353": "Rybacka 02",
  "31354": "Ceynowy SKM Śmiechowo 02",
  "31355": "SKM Pieleszewo 02",
  "31356": "Gdańska - Kościół 02",
  "31358": "Młyńska 02",
  "31359": "Młyńska 01",
  "31360": "Gdańska - Cmentarz 02",
  "31363": "Gdańska - Szkolna 01",
  "31368": "Łężyce - Głodówko 02",
  "31369": "Łężyce - Jeżynowa 01",
  "31372": "Łężyce - Jeżynowa 02",
  "31373": "Łężyce - Głodówko 01",
  "31374": "Łąkowa 02",
  "31375": "Orzeszkowej 01",
  "31376": "Orzeszkowej 02",
  "31377": "Obrońców Helu 01",
  "31380": "Grunwaldzka - Ceynowy 01",
  "31401": "Chwaszczyno Centrum 01",
  "31402": "Chwaszczyno Lisia 01",
  "31403": "Tuchom Ogrodowa 01",
  "31404": "Tuchom Stolema 01",
  "31405": "Miszewko Brzozowa 01",
  "31412": "Żukowo Dworcowa 03",
  "31415": "Miszewo Rolnicza 02",
  "31416": "Miszewko Brzozowa 02",
  "31417": "Tuchom Stolema 02",
  "31418": "Tuchom Ogrodowa 02",
  "31419": "Chwaszczyno Lisia 02",
  "31420": "Żukowo Os. Norbertanek 01",
  "31422": "Żukowo Jabłoniowa 01",
  "31426": "Żukowo Jabłoniowa 02",
  "31428": "Żukowo Os. Norbertanek 02",
  "31432": "Tuchom Tęczowa 01",
  "31433": "Tuchom Tęczowa 02",
  "31442": "Nowy Tuchom 01",
  "31443": "Nowy Tuchom 02",
  "31601": "Karczemki Tuchomska 08",
  "31602": "Karczemki 10",
  "31603": "Dobrzewino Kasztelańska 12",
  "31604": "Dobrzewino Dworska 14",
  "31605": "Bojano 18",
  "31606": "Bojano Kościół 20",
  "31607": "Bojano Kwiatowa 22",
  "31608": "Koleczkowo Gryfa Pomorskiego 26",
  "31609": "Koleczkowo Poczta 49",
  "31610": "Koleczkowo Kamieńska 51",
  "31611": "Koleczkowo Gryfa Pomorskiego 53",
  "31612": "Bojano Kwiatowa 57",
  "31613": "Bojano Kościół 59",
  "31614": "Bojano 61",
  "31615": "Dobrzewino Dworska 65",
  "31616": "Dobrzewino Kasztelańska 67",
  "31617": "Karczemki 69",
  "31618": "Chwaszczyno Boczna 71",
  "31619": "Dobrzewino Grabowa 03",
  "31620": "Dobrzewino Bojańska 05",
  "31621": "Kielno 09",
  "31622": "Kielno 26",
  "31623": "Kielno Partyzantów Koleczk. 01",
  "31624": "Bojano Graniczna 04",
  "31625": "Bojano Dębowa Karczma 02",
  "31626": "Bojano Dębowa Karczma 01",
  "31627": "Bojano Graniczna 03",
  "31628": "Kielno Partyzantów Koleczk. 02",
  "31629": "Dobrzewino Bojańska 30",
  "31630": "Dobrzewino Grabowa 32",
  "31631": "Chwaszczyno Poczta 06",
  "31632": "Chwaszczyno Poczta 73",
  "31633": "Dobrzewino Owsiana 16",
  "31634": "Dobrzewino Owsiana 63",
  "31637": "Kielno Różana 13",
  "31639": "Kielno Bożańska 17",
  "31640": "Kieleńska Huta 19",
  "31641": "Kamień Asnyka 21",
  "31642": "Kamień 23",
  "31643": "Szemud Moczydła 25",
  "31644": "Szemud Lesiniec 27",
  "31645": "Szemud Cmentarz 29",
  "31646": "Szemud 31",
  "31647": "Szemud Centrum Samorządowe 01",
  "31648": "Szemud 02",
  "31649": "Szemud Cmentarz 04",
  "31650": "Szemud Lesiniec 06",
  "31651": "Szemud Moczydła 08",
  "31652": "Kamień 10",
  "31653": "Kamień Asnyka 12",
  "31654": "Kieleńska Huta 14",
  "31655": "Kielno Bożańska 16",
  "31657": "Kielno Różana 20",
  "31658": "Kielno Sikorskiego 22",
  "31659": "Kielno Cmentarz 28",
  "31663": "Bojano Milenium 24",
  "31664": "Koleczkowo Kamieńska 28",
  "31665": "Bojano Milenium 55",
  "32010": "Poznańska 02",
  "32020": "Cmentarz Witomiński 02",
  "32030": "Węzeł Franciszki Cegielskiej 02",
  "32040": "Rolnicza  02",
  "32050": "Witomino Centrum 04",
  "32060": "Uczniowska 02",
  "32070": "Witomino Sosnowa 02",
  "32080": "Okrężna I 02",
  "32090": "Okrężna II 02",
  "32100": "Chwarzno Apollina 06",
  "32120": "Sokoła 02",
  "32130": "Chwarzno Polanki 02",
  "32140": "Kamrowskiego 02",
  "32150": "Zaruskiego 02",
  "32160": "Wiczlino Skrzyżowanie 01",
  "32170": "Gradowa 01",
  "32180": "Wiczlińska - Śliska 01",
  "32190": "Wiczlino Działki I 01",
  "32200": "Wiczlino Działki II 01",
  "32210": "Wiczlińska - Las 01",
  "32220": "Piołunowa 02",
  "32230": "Tymiankowa 02",
  "32240": "Dąbrowa Miętowa 01",
  "32250": "Tymiankowa 01",
  "32260": "Piołunowa 01",
  "32320": "Rdestowa - Kolonia 02",
  "32500": "Dąbrowa Miętowa 02",
  "32580": "Węzeł Franciszki Cegielskiej 10",
  "32600": "Węzeł Franciszki Cegielskiej 06",
  "32620": "Węzeł Franciszki Cegielskiej 08",
  "32630": "Węzeł Franciszki Cegielskiej 04",
  "32640": "Amona 02",
  "33010": "Redłowo SKM 08",
  "33030": "Plac Górnośląski 02",
  "33040": "Łowicka 02",
  "33050": "Olgierda 02",
  "33060": "Lidzka 02",
  "33070": "Racławicka 02",
  "33100": "Brzechwy 02",
  "33110": "Karwiny Tuwima 03",
  "33120": "Brzechwy 01",
  "33170": "Myśliwska 01",
  "33180": "Źródło Marii 01",
  "33190": "Karwiny PKM 01",
  "33200": "Racławicka 01",
  "33210": "Lidzka 01",
  "33220": "Olgierda 01",
  "33230": "Łowicka 01",
  "33240": "Plac Górnośląski 01",
  "33260": "Zwycięstwa - Wielkopolska 02",
  "33270": "Nawigatorów 02",
  "33280": "Orłowo SKM - Orłowska 02",
  "33290": "Orłowo SKM - 'Klif' 02",
  "33300": "Kolibki 02",
  "33310": "Bernadowska 02",
  "33320": "Bernadowska 01",
  "33330": "Kolibki 01",
  "33340": "Orłowo SKM - 'Klif' 01",
  "33350": "Orłowo SKM - Orłowska 01",
  "33360": "Nawigatorów 01",
  "33380": "Orłowo SKM - 'Klif' 04",
  "33400": "Redłowo SKM 06",
  "33440": "Karwiny Tuwima 01",
  "33460": "Orłowo SKM - 'Klif' 06",
  "33480": "Wielki Kack Starodworcowa 02",
  "33490": "Lipowa 02",
  "33510": "Gryfa Pomorskiego 01",
  "33520": "Lipowa 01",
  "33530": "Gryfa Pomorskiego 02",
  "33610": "Zwinisławy 02",
  "34010": "Kamienny Potok SKM - Niepodległości 02",
  "34020": "Kamienny Potok SKM 04",
  "34030": "Kamienny Potok - Kujawska 01",
  "34040": "Kamienny Potok SKM 03",
  "34090": "Brodwino 01",
  "34100": "Kolberga 01",
  "34110": "Junaków 01",
  "34120": "Łużycka 01",
  "34130": "Wejherowska 02",
  "34140": "Chodowieckiego 01",
  "34150": "Cmentarz 01",
  "34170": "Brodwino - Szkoła 02",
  "34180": "Cmentarz 02",
  "34190": "Malczewskiego 02",
  "34200": "Bohaterów Monte Cassino 02",
  "34310": "Sopot PKP - Niepodległości 02",
  "34390": "Jana z Kolna 02",
  "34400": "Rynek Non-Stop 01",
  "34420": "Mierosławskiego 01",
  "34460": "Grunwaldzka 01",
  "34470": "Chopina  01",
  "34480": "Grand Hotel 02",
  "34490": "Ceynowy  91",
  "34500": "Grand Hotel 01",
  "34510": "Chopina  03",
  "34520": "Sopot PKP 01",
  "34560": "Wejherowska 01",
  "34570": "Kamienny Potok SKM - Niepodległości 01",
  "34590": "Kraszewskiego 01",
  "34650": "Kamienny Potok - Kościół 01",
  "34660": "Łużycka 03",
  "34710": "Polna 03",
  "34730": "Sobieskiego - Przychodnia 02",
  "34740": "Sienkiewicza  02",
  "34750": "Sienkiewicza  01",
  "34760": "Schronisko Sopotkowo 01",
  "34780": "Schronisko Sopotkowo 02",
  "34790": "Architektów 01",
  "34810": "Mazowiecka 02",
  "34900": "Kraszewskiego 03",
  "34920": "Sikorskiego 03",
  "34930": "Wybickiego   01",
  "34940": "Kochanowskiego 03",
  "34980": "Korty Tenisowe 02",
  "34990": "Dolny Sopot - Haffnera 01",
  "35010": "Mały Kack Sandomierska 01",
  "35020": "Halicka 01",
  "35030": "Redłowo SKM 03",
  "35040": "Redłowo SKM - Park Technologiczny 02",
  "35050": "Zwycięstwa - Wielkopolska 04",
  "35060": "Zwycięstwa - Wielkopolska 01",
  "35070": "Redłowo SKM - Park Technologiczny 01",
  "35080": "Centrum Nauki Experyment 01",
  "35090": "Harcerska 01",
  "35100": "Wzgórze Św. Maksymiliana SKM 04",
  "35101": "Płyta Redłowska 04",
  "35102": "Piłsudskiego  03",
  "35103": "Ejsmonda 02",
  "35104": "Korczaka 01",
  "35106": "Gdynia Arena 02",
  "35107": "Gdynia Arena 01",
  "35110": "Urząd Miasta - Świętojańska 01",
  "35111": "Wzgórze Św. Maksymiliana SKM 01",
  "35112": "Wzgórze Św. Maksymiliana - Kapliczka 02",
  "35113": "Wzgórze Św. Maksymiliana SKM 03",
  "35115": "Kopernika - Partyzantów 02",
  "35116": "Focha 02",
  "35117": "Sosnowiecka 01",
  "35118": "Kurpiowska 02",
  "35119": "Kurpiowska 01",
  "35120": "Traugutta 01",
  "35121": "Sosnowiecka 02",
  "35130": "Żwirki i Wigury 01",
  "35140": "Skwer Kościuszki - InfoBox 01",
  "35150": "Plac Kaszubski - Świętojańska 01",
  "35160": "Plac Kaszubski - Świętojańska 02",
  "35170": "3 Maja 02",
  "35180": "Gdynia Dworzec Gł. PKP - Morska 02",
  "35190": "Gdynia Dworzec Gł. PKP - Morska 01",
  "35200": "3 Maja 01",
  "35210": "Centrum Handlowe Batory 01",
  "35220": "Skwer Kościuszki - InfoBox 02",
  "35230": "Żwirki i Wigury 02",
  "35240": "Traugutta 02",
  "35250": "Wzgórze Św. Maksymiliana SKM 06",
  "35260": "Harcerska 02",
  "35270": "Centrum Nauki Experyment 02",
  "35280": "Redłowo SKM 04",
  "35290": "Halicka 02",
  "35300": "Centrum Nauki Experyment 03",
  "35320": "Ruchu Oporu 02",
  "35330": "Powstań Chłopskich 02",
  "35340": "Redłowo Szpital 02",
  "35350": "Powstań Chłopskich 01",
  "35360": "Ruchu Oporu 01",
  "35370": "Cylkowskiego 02",
  "35380": "Płyta Redłowska 02",
  "35390": "Cylkowskiego 01",
  "35400": "Hallera 01",
  "35410": "Wzgórze Św. Maksymiliana Syrokomli 01",
  "35420": "Dom Marynarza 03",
  "35430": "Piłsudskiego  02",
  "35480": "Dom Marynarza 01",
  "35500": "Stadion Miejski 01",
  "35520": "Stadion Miejski 02",
  "35550": "Redłowo Szpital 01",
  "35560": "Moniuszki 01",
  "35570": "Norwida 02",
  "35600": "Korzeniowskiego 02",
  "35610": "Korzeniowskiego 01",
  "35620": "Mickiewicza  02",
  "35630": "Mickiewicza  01",
  "35640": "Necla  01",
  "35650": "Necla  02",
  "35690": "Dom Marynarza 05",
  "35710": "Wzgórze Św. Maksymiliana Syrokomli 02",
  "35720": "Szczeblewskiego 02",
  "35730": "Kopernika - Kościół 02",
  "35740": "Kopernika - Kościół 01",
  "35750": "Szczeblewskiego 01",
  "35770": "Fredry 02",
  "35800": "10 Lutego - Skwer Kościuszki 02",
  "35810": "Moniuszki 02",
  "35820": "Wybickiego 02",
  "35830": "Ejsmonda 01",
  "35850": "Łużycka  02",
  "35860": "Łużycka  01",
  "35870": "Wiosny Ludów 01",
  "35880": "Instytut Med. Morskiej i Tropikalnej 02",
  "35900": "Łowicka - Szkoła 02",
  "35910": "Mały Kack Sandomierska 03",
  "35920": "Wieluńska - Lipnowska 02",
  "35930": "Wieluńska - Radomska 02",
  "35940": "Mały Kack Łęczycka 01",
  "35950": "Olkuska - Radomska 01",
  "35960": "Olkuska - Łowicka 01",
  "35970": "Łowicka - Szkoła 01",
  "35980": "Instytut Med. Morskiej i Tropikalnej 01",
  "35990": "Wiosny Ludów 02",
  "36010": "Śląska 02",
  "36040": "Kilińskiego 01",
  "36050": "Armii Krajowej 03",
  "36060": "Armii Krajowej 01",
  "36070": "I Urząd Skarbowy 01",
  "36080": "Plac Kaszubski 03",
  "36090": "Plac Kaszubski 01",
  "36100": "Portowa 01",
  "36110": "Urząd Morski 02",
  "36120": "Plac Kaszubski - Jana z Kolna 02",
  "36130": "Gdynia Dworzec Gł. PKP - Hala 02",
  "36140": "Gdynia Dworzec Gł. PKP - Hala 04",
  "36150": "Gdynia Dworzec Gł. PKP - Hala 06",
  "36160": "Stocznia Gdynia 01",
  "36170": "Węzeł Ofiar Grudnia '70 05",
  "36180": "Celna 01",
  "36190": "Rotterdamska 01",
  "36200": "Szkoła Morska 01",
  "36210": "Chrzanowskiego 01",
  "36220": "Dworzec Morski - Muzeum Emigracji 01",
  "36230": "Chrzanowskiego 02",
  "36240": "Szkoła Morska 02",
  "36250": "Rotterdamska 02",
  "36260": "Celna 02",
  "36270": "Węzeł Ofiar Grudnia '70 06",
  "36280": "Węzeł Ofiar Grudnia '70 03",
  "36290": "Stocznia Gdynia 02",
  "36300": "Węzeł Ofiar Grudnia '70 04",
  "36310": "Węzeł Ofiar Grudnia '70 02",
  "36320": "Janka Wiśniewskiego 02",
  "36330": "Energetyków 02",
  "36340": "Energetyków 01",
  "36350": "Janka Wiśniewskiego 01",
  "36360": "Węzeł Ofiar Grudnia '70 01",
  "36370": "Gdynia Dworzec Gł. PKP 03",
  "36380": "Gdynia Dworzec Gł. PKP - Dworcowa 04",
  "36390": "Gdynia Dworzec Gł. PKP - Hala 03",
  "36400": "Gdynia Dworzec Gł. PKP - Hala 01",
  "36410": "Armii Krajowej 02",
  "36420": "Armii Krajowej 04",
  "36430": "Kilińskiego 02",
  "36440": "Urząd Miasta - Władysława IV 02",
  "36450": "Śląska 01",
  "36460": "Gdynia Dworzec Gł. PKP 07",
  "36470": "Chrzanowskiego - Przychodnia 01",
  "36480": "Chrzanowskiego - Przychodnia 02",
  "36490": "Gdynia Dworzec Gł. PKP 02",
  "36500": "Gdynia Dworzec Gł. PKP 04",
  "36520": "Gdynia Dworzec Gł. PKP 01",
  "36530": "Gdynia Dworzec Gł. PKP 05",
  "36540": "Gdynia Dworzec Gł. PKP 09",
  "36580": "3 Maja - Hala 03",
  "36590": "3 Maja - Hala 01",
  "37010": "Witomińska 01",
  "37020": "Warszawska 01",
  "37030": "Gdynia Dworzec Gł. PKP - Wolności 01",
  "37040": "Bpa Okoniewskiego 02",
  "37050": "Stocznia SKM - Morska 02",
  "37060": "Uniwersytet Morski 02",
  "37070": "Mireckiego 02",
  "37080": "Mireckiego 04",
  "37090": "Kalksztajnów 02",
  "37101": "Komandorska - Hotel 02",
  "37102": "Dembińskiego 02",
  "37103": "Mireckiego 08",
  "37104": "Sambora 02",
  "37105": "Krofeya 01",
  "37107": "Morska - Estakada 04",
  "37108": "Morska - Estakada 03",
  "37110": "Grabówek SKM 02",
  "37111": "Technikum Chłodnicze 02",
  "37113": "Leszczynki II 01",
  "37114": "Leszczynki II 02",
  "37115": "Leszczynki I 01",
  "37116": "Kordeckiego 03",
  "37120": "Morska - Estakada 02",
  "37130": "Węzeł Żołnierzy Wyklętych 02",
  "37140": "Zamenhofa 02",
  "37150": "Leszczynki SKM 02",
  "37160": "Pucka 02",
  "37170": "Chylonia Dworzec PKP 04",
  "37180": "Chylońska - Kcyńska 02",
  "37190": "Piaskowa 02",
  "37200": "Cisowa SKM 06",
  "37210": "Piaskowa 01",
  "37220": "Chylońska - Kcyńska 01",
  "37230": "Chylonia Dworzec PKP 01",
  "37240": "Pucka 01",
  "37250": "Leszczynki SKM 01",
  "37260": "Zamenhofa 01",
  "37270": "Zamenhofa 04",
  "37280": "Wiejska 02",
  "37290": "Chylonia Centrum 02",
  "37300": "Morska - Kcyńska 02",
  "37310": "Zbożowa 02",
  "37320": "Owsiana 02",
  "37330": "Cisowa Sibeliusa 02",
  "37340": "Cisowa Sibeliusa 01",
  "37350": "Owsiana 01",
  "37360": "Zbożowa 01",
  "37370": "Morska - Kcyńska 01",
  "37380": "Chylonia Centrum 01",
  "37390": "Wiejska 01",
  "37400": "Węzeł Żołnierzy Wyklętych 01",
  "37410": "Morska - Estakada 01",
  "37420": "Kalksztajnów 01",
  "37430": "Mireckiego 03",
  "37440": "Mireckiego 01",
  "37450": "Uniwersytet Morski 01",
  "37460": "Stocznia SKM - Morska 01",
  "37470": "Bpa Okoniewskiego 01",
  "37480": "Gdynia Dworzec Gł. PKP - Wolności 02",
  "37490": "Warszawska 02",
  "37500": "Witomińska 02",
  "37510": "Elektrowozownia SKM 02",
  "37520": "Elektrowozownia SKM 01",
  "37530": "Jęczmienna 01",
  "37540": "Jęczmienna 02",
  "37550": "Cisowa SKM 04",
  "37560": "Gdynia Dworzec Gł. PKP - Wolności 04",
  "37570": "Wolności - II LO 02",
  "37580": "Działki Leśne - Sztumska 01",
  "37590": "Szczecińska  01",
  "37600": "Liceum Jezuitów 02",
  "37610": "Nowogrodzka 02",
  "37620": "Cisowa SKM 02",
  "37630": "Cisowa Sibeliusa 03",
  "37660": "Tatrzańska - Olsztyńska 02",
  "37670": "Grabówek SKM 01",
  "37690": "Obwodnica - Kcyńska 01",
  "37700": "Chylonia Dworzec PKP 02",
  "37710": "Kwidzyńska I 01",
  "37720": "Kwidzyńska II 01",
  "37730": "Olsztyńska 01",
  "37740": "Urząd Pracy 02",
  "37750": "Kołłątaja 02",
  "37790": "Uniwersytet Morski 04",
  "37800": "Mireckiego 06",
  "37830": "Sambora - Kalksztajnów 02",
  "37840": "Stoigniewa 02",
  "37850": "Kordeckiego 01",
  "37860": "Ściegiennego 01",
  "37870": "Węzeł Żołnierzy Wyklętych 03",
  "37880": "Rozewska 02",
  "37890": "Ściegiennego 02",
  "37900": "Bażyńskiego 02",
  "37910": "Stoigniewa 01",
  "37920": "Sambora - Kalksztajnów 01",
  "37930": "Kalksztajnów - Bloki 01",
  "37940": "Uniwersytet Morski 06",
  "37950": "Grabowo 01",
  "37960": "Beniowskiego - Akademiki 01",
  "37970": "Plac Neptuna 01",
  "37980": "Urząd Pracy 01",
  "38020": "Chylonia Centrum 04",
  "38030": "Raduńska 02",
  "38040": "Jaskółcza 01",
  "38050": "Bławatna 02",
  "38060": "Wiklinowa 02",
  "38070": "Żurawia 02",
  "38080": "Pustki Cisowskie 01",
  "38090": "Żurawia 01",
  "38100": "Wiklinowa 01",
  "38110": "Bławatna 01",
  "38120": "Jaskółcza 02",
  "38130": "Chabrowa 04",
  "38140": "Rybińskiego 02",
  "38150": "Demptowo 01",
  "38160": "Demptowo - Jednostka Wojskowa 01",
  "38200": "Raduńska 01",
  "38210": "Chylonia Centrum 03",
  "38220": "Chylonia Dworzec PKP 03",
  "38240": "II Urząd Skarbowy 01",
  "38250": "Hutnicza - Stacja Paliw Lotos 01",
  "38260": "Hala 'Makro' 01",
  "38270": "Hutnicza - Estakada 01",
  "38280": "Hutnicza - Estakada 02",
  "38290": "Hutnicza - Estakada 04",
  "38300": "Hala 'Makro' 02",
  "38310": "Hutnicza - Stacja Paliw Lotos 02",
  "38320": "II Urząd Skarbowy 02",
  "38350": "Elektrociepłownia - Pucka 02",
  "38360": "Złota 02",
  "38370": "Złota 01",
  "38380": "Elektrociepłownia - Pucka 01",
  "38410": "Pucka - Hutnicza 04",
  "38420": "Meksykańska 02",
  "38440": "Hutnicza - Piaskowa 02",
  "38460": "Handlowa 02",
  "38470": "Hutnicza - Działki 02",
  "38480": "Hutnicza - Działki 01",
  "38490": "Handlowa 01",
  "38500": "Hutnicza - Piaskowa 01",
  "38520": "Meksykańska 01",
  "38530": "Pucka - Hutnicza 03",
  "38560": "Pustki Cisowskie 02",
  "38570": "Chylonia Dworzec PKP 06",
  "38590": "Chabrowa 02",
  "38600": "Skarbka I 02",
  "38610": "Skarbka II 02",
  "38620": "Jałowcowa 02",
  "38630": "Marszewska 02",
  "38640": "Ogród Botaniczny Marszewo 02",
  "38650": "Ogród Botaniczny Marszewo 01",
  "38660": "Marszewska 01",
  "38670": "Jałowcowa 01",
  "38680": "Leśniczówka Rogulewo 02",
  "38690": "Leśniczówka Rogulewo 01",
  "38700": "Swarzewska I 02",
  "38710": "Swarzewska II 02",
  "38720": "Swarzewska II 01",
  "38730": "Swarzewska I 01",
  "39010": "Gołębia 02",
  "39020": "Terminal Kontenerowy 03",
  "39030": "Obłuże Centrum 03",
  "39050": "Cechowa 01",
  "39060": "Nasypowa 02",
  "39070": "Stocznia Wojenna 02",
  "39080": "Akademia Marynarki Wojennej 02",
  "39090": "Oksywie Dolne 02",
  "39100": "Arciszewskich 02",
  "39110": "Muchowskiego 02",
  "39120": "Oksywie Górne 04",
  "39130": "Pancerna 02",
  "39140": "Oksywie Dickmana 01",
  "39150": "Pancerna 01",
  "39160": "Oksywie Górne 02",
  "39170": "Czwartaków 01",
  "39180": "Oksywie Godebskiego 02",
  "39190": "Alzacka 02",
  "39200": "Bosmańska - Zielona 04",
  "39210": "Dąbka - Zielona 04",
  "39220": "Zielona - Działki I 02",
  "39230": "Wąwóz Ostrowicki 02",
  "39240": "Zielona - Kościół 02",
  "39250": "Babie Doły 01",
  "39260": "Zielona - Kościół 01",
  "39270": "Wąwóz Ostrowicki 01",
  "39280": "Zielona - Działki I 01",
  "39290": "Zielona - Działki II 01",
  "39300": "Dąbka - Zielona 01",
  "39310": "Bosmańska - Zielona 01",
  "39320": "Alzacka 01",
  "39330": "Oksywie Górne 01",
  "39340": "Muchowskiego 01",
  "39350": "Arciszewskich 01",
  "39360": "Oksywie Dolne 01",
  "39370": "Akademia Marynarki Wojennej 01",
  "39380": "Stocznia Wojenna 01",
  "39390": "Nasypowa 01",
  "39400": "Bosmańska - Nasypowa 01",
  "39410": "Bosmańska - Zielona 02",
  "39420": "Bosmańska - Nasypowa 02",
  "39430": "Cechowa 02",
  "39440": "Obłuże Centrum 01",
  "39450": "Terminal Kontenerowy 01",
  "39460": "Gołębia 01",
  "39470": "Elektrociepłownia - Kontenerowa 02",
  "39480": "Terminal Kontenerowy 04",
  "39490": "Zielona - Działki II 02",
  "39500": "Babie Doły 03",
  "39510": "Oksywie Dickmana 02",
  "39560": "Oksywie Dolne 04",
  "39591": "Koleczkowo Łąkowa 02",
  "39592": "Koleczkowo Młyńska 04",
  "39593": "Koleczkowo Młyńska 01",
  "39594": "Koleczkowo Łąkowa 03",
  "39596": "Dworzec Morski - Muzeum Emigracji 03",
  "39599": "Kielno Cmentarz 07",
  "39600": "Kamienny Potok SKM 06",
  "39604": "Kosakowo - Centrum Sportowe 02",
  "39605": "Kosakowo - Centrum Sportowe 01",
  "40051": "Dębogórze - Partyzantów 02",
  "40052": "Dębogórze - Partyzantów 01",
  "40056": "Kazimierz - Listopadowa 02",
  "40064": "Reja 01",
  "40068": "Sportowa 01",
  "40070": "Spokojna - Cmentarz 01",
  "40075": "Filipkowskiego 01",
  "40076": "Filipkowskiego 02",
  "40077": "Szemud Błaszkowskiego 02",
  "40079": "Karwiny PKM 04",
  "40080": "Władysława Jagiełły 02",
  "40081": "Grenadierów 02",
  "40082": "Mały Kack Strzelców 02",
  "40083": "Grenadierów 01",
  "40084": "Dębogórze-Wybudowanie - Boisko 02",
  "40085": "Dębogórze-Wybudowanie - Boisko 01",
  "40086": "Korty Tenisowe 04",
  "40087": "Mazowiecka 02",
  "40088": "Pomorska - Gdańska 01",
  "40090": "Wielki Kack Fikakowo 02",
  "40091": "Wielki Kack Fikakowo 01",
  "40092": "Gdańska 01",
  "40093": "Rumia Partyzantów 05",
  "40094": "Rumia Partyzantów 06",
  "40095": "Świętopełka 01",
  "40096": "Świętopełka 02",
  "40097": "Stara Rumia Cmentarz 01",
  "40098": "Stara Rumia Cmentarz 02",
  "40099": "Jeziorna 01",
  "40100": "Jeziorna 02",
  "40102": "Okrzei 01",
  "40133": "Polna 04",
  "40174": "Kwiatkowskiej 02",
  "40175": "Staniszewskiego 01",
  "40176": "Bryla 01",
  "40177": "Bryla 02",
  "40178": "Staniszewskiego 02",
  "40179": "Kwiatkowskiej 01",
  "40181": "Kielno Słoneczna 15",
  "40182": "Kielno Słoneczna 18",
  "40183": "Stadion Miejski 03",
  "40184": "Stadion Miejski 04",
  "40185": "Stadion PKM 01",
  "40186": "Stadion PKM 02",
  "40187": "Korczaka 02",
  "40191": "Bulwar Nadmorski 01",
  "40192": "Bulwar Nadmorski 02",
  "40194": "Nałkowskiej 04",
  "40197": "Rewa - Bursztynowa 03",
  "40201": "Kielno Rondo 24",
  "40202": "Kielno Rondo 11",
  "40203": "Pieńkawy 02",
  "40207": "Dębogórze-Wybudowanie - Długa 04",
  "40208": "Starowiejska 02",
  "40212": "Łokietka 02",
  "40213": "Ergo Arena 01",
  "40214": "Ergo Arena 02",
  "40215": "Ergo Arena 04",
  "40216": "Ergo Arena 03",
  "40217": "Wzgórze Św. Maksymiliana SKM 02",
  "40219": "Lutycka 02",
  "40221": "Gryfa Pomorskiego 04",
  "40222": "Górnicza - Damroki 02",
  "40223": "Górnicza - Kościół 02",
  "40233": "Demptowska 02",
  "40234": "Demptowo 02",
  "40235": "Skarbka II 01",
  "40236": "Skarbka I 01",
  "40237": "Chabrowa 01",
  "40240": "Elektrociepłownia - Kontenerowa 01",
  "40248": "Oksywie Godebskiego 04",
  "40251": "Reda Bosmańska 02",
  "40252": "CH 'Port Rumia' - Kosynierów 02",
  "40257": "Łokietka 01",
  "40261": "Kapitańska 02",
  "40262": "Plac Neptuna 02",
  "40263": "Grabowo 02",
  "40266": "Czernickiego I 01",
  "40267": "Czernickiego I 02",
  "40268": "Kręta 01",
  "40269": "Piłsudskiego 01",
  "40270": "Kosakowo - Centrum Handlowe 02",
  "40271": "Kosakowo - Centrum Handlowe 01",
  "40273": "Pogórze - Derdowskiego 02",
  "40275": "Kacze Buki 03",
  "40276": "Bieszczadzka 02",
  "40277": "Kacze Buki Puszczyka 01",
  "40278": "Bieszczadzka 01",
  "40279": "Kacze Buki 04",
  "40285": "Podleśna 02",
  "40291": "Kacze Buki 02",
  "40292": "Krzemowa 01",
  "40293": "Krzemowa 02",
  "40294": "Kacze Buki 01",
  "40297": "Witomino Leśniczówka 03",
  "40298": "Witomino Leśniczówka 04",
  "40303": "Dworzec Morski - Muzeum Emigracji 05",
  "40304": "Publiczny Terminal Promowy 02",
  "40305": "Żeglarzy 01",
  "40306": "Żeglarzy 02",
  "40307": "Sucharskiego 01",
  "40308": "Sucharskiego 02",
  "40312": "Chylonia Dworzec PKP - os. Meksyk 03",
  "40313": "Chylonia Dworzec PKP - os. Meksyk 01",
  "40321": "Dobrzewino Królewska 01",
  "40322": "Dobrzewino Klonowa 34",
  "40323": "Reda Bosmańska 01",
  "40326": "Mały Kack Strzelców 01",
  "40327": "Kosakowo - Gryfa Pomorskiego 01",
  "40328": "Kosakowo - Gryfa Pomorskiego 02",
  "40337": "Górnicza 01",
  "40340": "Hutnicza - Magazyny 01",
  "40341": "Hutnicza - Magazyny 02",
  "40343": "Pogórze - Obrońców Wybrzeża 01",
  "40344": "Pogórze - Obrońców Wybrzeża 02",
  "40345": "Pogórze - Przedszkole 01",
  "40346": "Pogórze - Przedszkole 02",
  "40347": "Pogórze - Dąbrowskiego 02",
  "40349": "Gdańska 02",
  "40350": "Suchy Dwór - Świetlica 01",
  "40351": "Dębogórze - Gronowa 01",
  "40352": "Dębogórze - Gronowa 02",
  "40353": "Suchy Dwór - Świetlica 04",
  "40357": "Pucka - Przemysłowa 01",
  "40358": "Władysława Jagiełły 01",
  "40359": "Nałkowskiej 01",
  "40362": "Janowo SKM - Sobieskiego 06",
  "40368": "Karwiny Nowowiczlińska 02",
  "40374": "Obłuże Centrum 02",
  "40375": "Nadrzeczna 02",
  "40376": "Chwarzno Apollina 03",
  "40377": "Jowisza 02",
  "40378": "Chwarzno Apollina 01",
  "40379": "Jowisza 01",
  "40380": "Chwarzno Polanki 03",
  "40381": "Janowo SKM - Sobieskiego 08",
  "40385": "Ormińskiego 02",
  "40386": "Saperów 01",
  "40387": "Saperów 02",
  "40390": "Janowo SKM - Sobieskiego 03",
  "40391": "Janowo SKM - Sobieskiego 04",
  "40393": "Promienna 01",
  "40394": "Łężyce - Jarzębinowa 01",
  "40395": "Łężyce - Jarzębinowa 02",
  "40396": "Pucka - Przemysłowa 02",
  "40398": "Łężyce - Wierzbowa 01",
  "40399": "Łężyce - Wierzbowa 02",
  "40400": "Chwaszczyno Derdowskiego 02",
  "40407": "Młyńska 02",
  "40408": "Plac Kusocińskiego 02",
  "40409": "Dębogórze - Sezamkowa 01",
  "40410": "Dębogórze - Sezamkowa 02",
  "40411": "Suchy Dwór - Przepiórcza 01",
  "40412": "Suchy Dwór - Przepiórcza 02",
  "40413": "Młyńska 01",
  "skm_178829": "Gdynia Cisowa",
  "skm_251577": "Gdańsk Oliwa",
  "skm_254531": "Lębork Mosty",
  "skm_258458": "Gdańsk Śródmieście",
  "skm_5256": "LĘBORK",
  "skm_5413": "Godętowo",
  "skm_5421": "Bożepole Wielkie",
  "skm_5439": "Strzebielino Morskie",
  "skm_5447": "Luzino",
  "skm_5900": "GDYNIA GŁÓWNA",
  "skm_5918": "Gdynia Redłowo",
  "skm_5926": "Gdynia Wzg. Św. Maksymiliana",
  "skm_5934": "Gdynia Orłowo",
  "skm_5942": "SOPOT",
  "skm_5959": "Sopot Kamienny Potok",
  "skm_5967": "Sopot Wyścigi",
  "skm_6031": "GDYNIA CHYLONIA",
  "skm_6049": "Gdynia Stocznia",
  "skm_6056": "Gdynia Grabówek",
  "skm_6064": "Gdynia Leszczynki",
  "skm_6080": "Rumia Janowo",
  "skm_6098": "RUMIA",
  "skm_6106": "REDA",
  "skm_6114": "Reda Pieleszewo",
  "skm_6304": "WEJHEROWO",
  "skm_6312": "Wejherowo Śmiechowo",
  "skm_6320": "Wejherowo Nanice",
  "skm_6593": "Gościcino Wejherowskie",
  "skm_7500": "GDAŃSK GŁÓWNY",
  "skm_7518": "Gdańsk Stocznia",
  "skm_7526": "Gdańsk Politechnika",
  "skm_7534": "GDAŃSK WRZESZCZ",
  "skm_7559": "Gdańsk Zaspa",
  "skm_7567": "Gdańsk Przymorze - Uniwersytet",
  "skm_7617": "Gdańsk Żabianka - AWFiS"
}